'use strict';

var frontendUtils = require('honda_cars_ecux/utils/frontendUtils');
var analyticsHelper = require('app_honda_cars/utils/analyticsHelper');
var scrollUtils = require('../utils/scrollUtils');
var offcanvas = require('honda_cars_ecux/ecux/vendors/bootstrap-5.3/offcanvas');
var singleTabConfigurator = require('./features/singleTabConfigurator');
var configuratorRecommendation = require('./features/configuratorRecommendation');
var saveToCxpGate = require('./features/saveToCxpGate');
var configuratorStageConfigure = require('./stage/configuratorStageConfigure');
var configuratorStageSummary = require('./stage/configuratorStageSummary');
var configuratorFooter = require('./stage/configuratorFooter');
var productDisclalmers = require('./components/product-disclalmers');
var configuratorPromotion = require('./components/configuratorPromotion');
var configuratorGradesAccordion = require('./components/configuratorGradesAccordion');
var configuratorDownloadBrochure = require('./components/configuratorDownloadBrochure.js');
var buildCTAEvaluator = require('./buildCTAEvaluator');
var configuratorChangeVINMode = require('./components/configuratorChangeVINMode');
const { configuratorCtas } = require('./configuratorCtas');
const { changeCentreCtas } = require('./changeCentreCtas');
const { feedback } = require('app_honda_cars/utils/feedback');

const { saveExecutionGate } = require('../coordinator/saveExecutionGate');
const { tabIdentity } = require('../utils/tabIdentity');
const { urlHelper } = require('amb/helpers/url.helper');
const { commonOptions } = require('amb_base/options/common.options');
const { dwService } = require('amb_base/services/dw.service');
const { scrollDirective } = require('amb_base/directives/scroll.directive');

window.globalAccessoryData = {};
window.testDriveGlobalAccessoryData = {};
window.globalSaveuniqueCode = {};
window.globalTestDriveuniqueCode = {};

const IS_TAB_ISOLATION = tabIdentity.isTabIsolation();

var processInclude = require('base/util');
processInclude(require('../stores/stores'));

const FEATURES = {
    singleTabConfigurator: !IS_TAB_ISOLATION,
    configuratorRecommendation: true,
    saveToCxpGate: true
};

window.configurator = {
    /** CTAs gated by dealer onlineOrderingEnabled — always in DOM, toggled via Variation. */
    ONLINE_ORDERING_CTA_SELECTOR: configuratorCtas.ONLINE_ORDERING,

    footer: {
        /**
         * Open the configurator flyout to the "Change Honda Centre" view.
         *
         * Replaces the legacy `#modal-location` / `#offcanvas-location` popups.
         *
         * @param {{ forceOpen?: boolean }} [options] When `forceOpen` is true (first-visit prompt),
         *  the close/backdrop interactions are disabled until a location is confirmed.
         */
        openChangeHondaCentreView: function (options) {
            var forceOpen = !!(options && options.forceOpen);
            var $modal = $('.configurator-modal');
            if (!$modal.length) return;

            $modal.modal({
                backdrop: forceOpen ? 'static' : true,
                keyboard: !forceOpen
            });

            $modal[0]?.setView('showroom-locator');

            if (forceOpen) {
                $modal.find('.close, .btn-back').hide();
                $modal.one('hide.bs.modal', function (event) {
                    if (!frontendUtils.getCookie('userloc')) {
                        event.preventDefault();
                    }
                });
            } else {
                $modal.find('.close').show();
            }
        },

        /**
         * True when userloc has the fields written by Google Places selection
         * (postalCode + state). An empty "{}" cookie must not count as set.
         */
        hasValidUserLocation: function (cookieValue) {
            if (!cookieValue) {
                return false;
            }
            try {
                var location = JSON.parse(cookieValue);
                return !!(location && location.postalCode && location.state && location.state.code);
            } catch (e) {
                return false;
            }
        },
        validateUserLocation: function () {
            let populateLocationInfo = this.populateLocationInfo;
            let populateDealersInfo = this.populateDealersInfo;
            let openChangeHondaCentreView = this.openChangeHondaCentreView;
            var params = new URLSearchParams(window.location.search);
            var dealerCode = params.get('dealerCode') || '';
            var orderId = params.get('orderId') || '';
            var userLocationCookie = frontendUtils.getCookie('userloc');
            var hasValidLocation = this.hasValidUserLocation(userLocationCookie);
            if (hasValidLocation && dealerCode != '') {
                var userLocation = JSON.parse(userLocationCookie || 'null');
                populateLocationInfo(userLocation.summary);
                populateDealersInfo();
            } else if (!hasValidLocation || dealerCode != '') {
                if (dealerCode != '') {
                    setDealerID(dealerCode, orderId);
                    setTimeout(() => {
                        var userLocation = JSON.parse(frontendUtils.getCookie('userloc') || 'null');
                        populateLocationInfo(userLocation.summary);
                        populateDealersInfo();
                    }, 1000);
                } else {
                    openChangeHondaCentreView({ forceOpen: true });
                }
            } else {
                var userLocation = JSON.parse(userLocationCookie || 'null');
                populateLocationInfo(userLocation.summary);
                populateDealersInfo();
            }

        },
        actionLocationConfirm: function () {

            $('#configurator-location-confirm').on('click', function (event) {
                event.preventDefault();
                var $configuratorGoogleInput = $('#configurator-google-autocomplete');
                var $configuratorGoogleInputInvalid = $('#configurator-google-autocomplete-invalid');
                var $userLocationInputInvalid = $('#user-location-input-invalid');
                var $locationApiError = $('#configurator-location-error-msg');
                var params = new URLSearchParams(window.location.search);
                var userId = params.get('userId') || '';
                var sessionId = params.get('sessionId') || '';
                var orderId = params.get('orderId') || '';
                var openLocationModal = params.get('openLocationModal') || '';
                var locationModalValue = openLocationModal && openLocationModal === 'true';

                $locationApiError.removeClass('d-flex');

                if (!$configuratorGoogleInput.val()) {
                    $configuratorGoogleInputInvalid.html($userLocationInputInvalid.data('empty'));
                    $userLocationInputInvalid.addClass('d-flex');
                    $configuratorGoogleInput.trigger('focus');
                    return false;
                }

                if ($configuratorGoogleInput.val().length < 4) {
                    $configuratorGoogleInputInvalid.html($userLocationInputInvalid.data('invalid'));
                    $userLocationInputInvalid.addClass('d-flex');
                    $configuratorGoogleInput.trigger('focus');
                    return false;
                }

                // Require a Places selection (tempuserloc) or an already-valid userloc.
                // Typed-only postcode never writes tempuserloc — block confirm/reload.
                var tempUserLocCookie = frontendUtils.getCookie('tempuserloc');
                var hasSelectedPlace = configurator.footer.hasValidUserLocation(tempUserLocCookie);
                var hasExistingLocation = configurator.footer.hasValidUserLocation(
                    frontendUtils.getCookie('userloc')
                );

                if (!hasSelectedPlace && !hasExistingLocation) {
                    $configuratorGoogleInputInvalid.html($userLocationInputInvalid.data('invalid'));
                    $userLocationInputInvalid.addClass('d-flex');
                    $configuratorGoogleInput.trigger('focus');
                    return false;
                }

                if (orderId && userId && sessionId) {
                    if (!tempUserLocCookie) {
                        return false;
                    }

                    var tempuserloc = JSON.parse(tempUserLocCookie);
                    var tempState = tempuserloc.state.code;
                    var orderLocationAction = $(this).data('locationcheckaction');
                    var isShowroomLocator = this.closest('.modal-view[view="showroom-locator"]')
                    var invalidUserLocation = false;

                    $.ajax({
                        url: orderLocationAction,
                        type: 'get',
                        dataType: 'json',
                        async: false,
                        data: {
                            orderId: orderId,
                            tempState: tempState
                        },
                        success: function (data) {
                            if (isShowroomLocator && data.error && data.message) {
                                invalidUserLocation = true;

                                var toastContainer = document.querySelector('.modal-view[view="showroom-locator"] .toast-container');

                                feedback.toast({
                                    message: data.message,
                                    toastClass: 'toast-error',
                                    delay: 8000,
                                    container: toastContainer
                                });
                            }
                        }
                    });

                    if (invalidUserLocation) {
                        return false;
                    }
                }

                $userLocationInputInvalid.removeClass('d-flex');
                $locationApiError.removeClass('d-flex');

                if (locationModalValue) {
                    frontendUtils.deleteUrlParams('openLocationModal');
                }

                $('body').trigger('configurator:footer:location:confirmed', [{
                    toastType: resolveHondaCentreChangedToastType()
                }]);
            });

            $('body').on('location:afterUpdate', function (event, data) {
                const cookieID = data.cookieID || 'userloc';
                const userLocation = JSON.parse(frontendUtils.getCookie(cookieID));

                if (userLocation && userLocation.summary) {
                    if (cookieID === 'tempuserloc') {
                        $('#sidebar-configurator-google-autocomplete').val(userLocation.summary);
                    }
                }
                $('.configurator-location--invalid-error-msg').removeClass('d-flex');
            });

            $('#configurator-useMyLocation').on('click', function () {
                $('body').trigger('location:confirmLocation');

                $('body').on('location:afterUpdate', function (event, data) {
                    const cookieID = data.cookieID || 'userloc';
                    const userLocation = JSON.parse(frontendUtils.getCookie(cookieID));

                    if (userLocation && userLocation.summary) {
                        $('#configurator-google-autocomplete').val(userLocation.summary);
                    }
                });

                setTimeout(function () {
                    var locationInputValue = $('#configurator-google-autocomplete').val();
                    var $apiError = $('#configurator-location-error-msg');
                    var $manualValidationError = $('#user-location-input-invalid');

                    $manualValidationError.removeClass('d-flex');

                    if (!locationInputValue) {
                        $apiError.addClass('d-flex');
                    } else {
                        $apiError.removeClass('d-flex');
                    }
                }, 3500);
            });

            $('.configurator-test-drive #sidebar-useMyLocation').on('click', function () {
                setTimeout(function () {
                    var locationInputValue = $('.configurator-test-drive #sidebar-configurator-google-autocomplete').val();
                    var $apiError = $('.configurator-test-drive #configurator-location-error-msg');

                    if (!locationInputValue) {
                        $apiError.addClass('d-flex');
                    } else {
                        $apiError.removeClass('d-flex');
                    }
                }, 1500);
            });
        },
        setUserDealersInfo: function (selector) {
            let $userLocationDealers = $(selector);
            if ($userLocationDealers.length) {
                let userDealer = {
                    dealerId: $userLocationDealers.val(),
                    dealerName: $userLocationDealers.data('dealername'),
                    portId: $userLocationDealers.data('portid').toString(),
                    expertId: $userLocationDealers.data('expertid').toString()
                };
                $('body').trigger('stores:updateLocationWithPortDealer', userDealer);
            }
        },
        populateDealersInfo: function () {
            let userLocation = null;
            userLocation = JSON.parse(frontendUtils.getCookie('userloc') || 'null');
            var $configuratorTestDriveForm = $('#configurator-test-drive-form');
            if (userLocation.dealer) {
                $(`#configurator-location-confirm`).removeAttr('disabled');
                $('#configurator-footer-dealer-name').html(userLocation.dealer.dealerName);
                $configuratorTestDriveForm.find('#sidebar-edit-location-summary').html(userLocation.summary);
                $configuratorTestDriveForm.find('#user-location-summary').addClass('d-flex');
                $configuratorTestDriveForm.find('#user-location-input').removeClass('d-flex').addClass('d-none');
            }
        },
        populateLocationInfo: function (userLocationSummary) {
            $('#configurator-footer-location-summary').html(userLocationSummary);
            configurator.header.populateDriveAwayPrice();

            var userLocation = JSON.parse(frontendUtils.getCookie('userloc') || 'null');
            frontendUtils.updateUrlParams({
                'suburb': userLocation.city,
                'pc': userLocation.postalCode,
                'state': userLocation.state.code
            });
        },
        initFooterActions: function () {
            let openChangeHondaCentreView = this.openChangeHondaCentreView;
            let $configuratorModal = $('.configurator-modal');
            let $locationConfirmButton = $('#configurator-location-confirm');
            let $locationinputfield = $('#configurator-google-autocomplete');
            let populateLocationInfo = this.populateLocationInfo;
            let setUserDealersInfo = this.setUserDealersInfo;
            let populateDealersInfo = this.populateDealersInfo;
            var params = new URLSearchParams(window.location.search);
            var orderId = params.get('orderId') || '';
            var action = params.get('action') || '';
            let lastConfirmedLocation = '';
            var openLocationModal = params.get('openLocationModal') || '';
            var locationModalValue = openLocationModal && openLocationModal === 'true';

            // Reset the location form state when the configurator flyout closes without a confirmed location
            // (mirrors the legacy `hidden.bs.modal` / `hidden.bs.offcanvas` cleanup that lived on the deleted
            // `#modal-location` and `#offcanvas-location` popups).
            $configuratorModal.on('hidden.bs.modal', function () {
                if ($locationinputfield.val().trim() !== lastConfirmedLocation) {
                    $locationConfirmButton.data('locationConfirmed', false);
                    $locationinputfield.val('');
                    $('#configurator-location-dealers').html('');
                    $('.confirm-btn').attr('disabled', true);
                    $('.js-delete-location').hide();
                }
                if (locationModalValue) {
                    frontendUtils.deleteUrlParams('openLocationModal');
                }
            });

            $locationConfirmButton.on('click', function () {
                const currentLocation = $locationinputfield.val().trim();
                if (currentLocation) {
                    lastConfirmedLocation = currentLocation;
                    $(this).data('locationConfirmed', true);
                }
            });

            // The "Change Honda Centre" CTA in the configurator main-menu uses `data-view="showroom-locator"`
            // which is handled by the navigation router. The legacy `.configurator-footer-change-location-button`
            // selector is kept here as a safety net for any other entry points (e.g. CXP flow).
            $('.configurator-footer-change-location-button').on('click', function (e) {
                var $this = $(this);
                if (FEATURES.singleTabConfigurator) {
                    if ($this.hasClass('duplicate-tab-blocker')) {
                        e.preventDefault();
                        singleTabConfigurator.showBlockedNotification();
                        return false;
                    }
                }
                openChangeHondaCentreView();
            });

            // Showroom locator: clear-icon mirrors empty-input behaviour (`#configurator-google-autocomplete` keyup).
            $('body').on('click', '.js-delete-location', function (e) {
                e.preventDefault();
                var $input = $('#configurator-google-autocomplete');
                $('#configurator-location-dealers').html('');
                $input.val('');
                $input.trigger('focus');
                $('.confirm-btn').attr('disabled', true);
                $(this).hide();
            });

            $('body').on('configurator:footer:location:confirmed', function (el, data) {
                var $currentProduct = $('#current-product');
                let $configuratorLocationConfirm = $('#configurator-location-confirm');

                setTimeout(() => {
                    $.ajax({
                        url: $configuratorLocationConfirm.data('action'),
                        type: 'get',
                        dataType: 'json',
                        data: {
                            pid: $currentProduct.data('selectedvariationid'),
                        },
                        success: function (response) {
                            if ($configuratorLocationConfirm.hasClass('configurator-stage-summary')) {
                                frontendUtils.updateUrlParams({ 'showSummary': 'true' });
                            }

                            // First location set → `confirm`; update existing userloc → `change` (see resolveHondaCentreChangedToastType).
                            try {
                                sessionStorage.setItem('hondaCentreChangedToast', toastType);
                            } catch (e) { /* noop - sessionStorage may be unavailable */ }
                            $('body').spinner().start();
                            window.location.reload();
                        }
                    });
                }, 600);

                $('body').trigger('location:confirmLocation');

                $configuratorModal.modal('hide');
            });

            var assignedDealerSnapshot = null;

            function isAssignedDealerContext() {
                var qs = new URLSearchParams(window.location.search);
                return !!(qs.get('orderId') || qs.get('userId') || qs.get('sessionId') || qs.get('dealerCode'));
            }

            $('body').on('location:beforeConfirmLocation', function () {
                assignedDealerSnapshot = null;
                if (!isAssignedDealerContext()) return;
                var currentLocation = JSON.parse(frontendUtils.getCookie('userloc') || 'null');
                if (!currentLocation) return;
                try {
                    var loc = currentLocation;
                    if (loc && loc.dealer && loc.dealer.dealerId) {
                        assignedDealerSnapshot = loc.dealer;
                    }
                } catch (e) {
                    assignedDealerSnapshot = null;
                }
            });

            $('body').on('location:afterConfirmLocation', function () {
                var userLocation = JSON.parse(frontendUtils.getCookie('userloc') || 'null');
                populateLocationInfo(userLocation.summary);
                // Scope to the showroom-locator flyout's dealer list. The `stores:getDealers` AJAX
                // populates the same HTML into the test-drive sidebar (`#configurator-location-dealers-test-drive`)
                // and finance modal (`#summary-location-dealers-for-finance`) too — each with its own
                // first-store-checked default — so a global `:checked` selector would match multiple radios
                // and `$.val()` would return whichever appears first in DOM order, not the user's actual choice.
                setUserDealersInfo("#configurator-location-dealers input[name='user-location-dealers']:checked");
                populateDealersInfo();

                if (assignedDealerSnapshot) {
                    try {
                        var loc = JSON.parse(frontendUtils.getCookie('userloc') || '{}') || {};
                        loc.dealer = assignedDealerSnapshot;
                        frontendUtils.setCookie('userloc', JSON.stringify(loc));
                        $('#configurator-footer-dealer-name').html(assignedDealerSnapshot.dealerName);
                    } catch (e) {
                        // ignore; reload will surface cookie issues
                    }
                    assignedDealerSnapshot = null;
                }
            });

            var $saveAndShareForm = $('#configurator-save-and-share');
            if ($('#share-details-form-toggle').not(':checked')) {
                $saveAndShareForm.find('#details-form-firstname').prop('required', false);
                $saveAndShareForm.find('#details-form-lastname').prop('required', false);
                $saveAndShareForm.find('#details-form-phone').prop('required', false);
            }

            // Footer "Save" CTA opens the redesigned flyout (view="save-build"); the legacy
            // #configurator-save-and-share-modal has been retired. uniqueBuildCode.js fetches the
            // unique build code on view change.
            $('.configurator-footer-actions-save').on('click', () => {
                var flyout = document.querySelector('.configurator-modal');

                if (flyout && typeof flyout.setView === 'function') {
                    flyout.setView('save-build');
                    $(flyout).modal('show');
                }
            });

            // Footer offline "Share with customer" CTA opens the redesigned flyout (view="share-build");
            // the legacy #offline-order-build-share-modal has been retired. shareBuild.js owns the
            // dealer/offline lead submission and uniqueBuildCode.js fetches the unique build code.
            $('.offline-configurator-footer-action-share').on('click', () => {
                var flyout = document.querySelector('.configurator-modal');

                if (flyout && typeof flyout.setView === 'function') {
                    flyout.setView('share-build');
                    $(flyout).modal('show');
                }
            });

            $('#configurator-save-build-cta').on('click', () => {
                var $saveBuildCta = $('#configurator-save-build-cta');

                if (IS_TAB_ISOLATION && !saveExecutionGate.beginSaveGateAction($saveBuildCta)) {
                    return;
                }

                var selectedVariationId = $('#current-product').attr('data-selectedvariationid');
                var url = $saveBuildCta.data('action');
                var saveBuild = true;
                var urlParams = window.location.search;
                var urlSubstring = urlParams.substring(1);
                var params = new URLSearchParams(urlParams);
                var code = params.get('code') || '';
                var userId = params.get('userId') || '';
                var sessionId = params.get('sessionId') || '';
                var recordType = params.get('relatedRecordType') || '';
                var recordId = params.get('recordId') || '';
                var isOpportunity = false;
                if (recordType != '' && recordType == 'Opportunity') {
                    isOpportunity = true;
                }
                var $productBuildYearFull = $('.internal-Vehicle-number').find('input[name="productionDate"]').attr('value');
                var $buildYear = null;
                if ($productBuildYearFull) {
                    var $BuildYearDateObject = new Date($productBuildYearFull);
                    $buildYear = $BuildYearDateObject.getFullYear();
                }
                var updateExistingCode = false;
                if (sessionId != '' && userId != '' && code != '') {
                    updateExistingCode = true;
                }
                $.ajax({
                    url: url,
                    type: 'post',
                    data: {
                        pid: selectedVariationId,
                        saveBuild: saveBuild,
                        urlParams: urlSubstring,
                        code: code,
                        userId: userId ? userId : '',
                        updateExistingCode: updateExistingCode,
                        sessionId: sessionId,
                        isOpportunity: isOpportunity,
                        recordType: recordType,
                        recordId: recordId,
                        buildYear: $buildYear
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.messageemail) {
                            $('.invalid-email-error').text(data.messageemail);
                        } else {
                            $('.invalid-email-error').empty();
                            $('.configurator-modal').modal('hide');
                            $('.toast-save-build-success-message').toast('show');
                            $('body').trigger('gtm:event', { callback: 'configuratorSaveBuildComplete', data: null });
                        }
                    },
                    complete: function () {
                        if (IS_TAB_ISOLATION) {
                            saveExecutionGate.completeSaveGateAction($saveBuildCta);
                        }
                    }
                });
            });

            $('.configurator-send-offine-order-cta').on('click', (e) => {
                e.preventDefault();

                var $offlineCta = $('.configurator-send-offine-order-cta');

                if (IS_TAB_ISOLATION && !saveExecutionGate.beginSaveGateAction($offlineCta)) {
                    return;
                }

                var selectedVariationId = $('#current-product').attr('data-selectedvariationid');
                var url = $('#offline-send-order').data('action');
                var $form = $('#configurator-save-and-share');
                var urlParams = window.location.search;
                var urlSubstring = urlParams.substring(1);
                var params = new URLSearchParams(urlParams);
                var code = params.get('code');
                var userId = params.get('userId') || '';
                var sessionId = params.get('sessionId') || '';
                var recordType = params.get('relatedRecordType') || '';
                var showroomStock = params.get('showroomStock') || '';
                var recordId = params.get('recordId') || '';
                var isOpportunity = false;
                var isShowroomStock = false;
                if (recordType != '' && recordType == 'Opportunity') {
                    isOpportunity = true;
                }
                if (showroomStock == 'true') {
                    isShowroomStock = true;
                }
                var updateExistingCode = false;
                if (sessionId != '' && userId != '' && code != '') {
                    updateExistingCode = true;
                }
                var internalVehicleNumber = $('.internal-Vehicle-number').find('input[name="internalVehicleNumber"]').attr('value') || '';
                $(configuratorCtas.CXP).addClass('disabled');
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'post',
                    data: {
                        pid: selectedVariationId,
                        urlParams: urlSubstring,
                        code: code,
                        email: $form.find('#details-form-email').val(),
                        userId: userId ? userId : '',
                        updateExistingCode: updateExistingCode,
                        sessionId: sessionId,
                        isOpportunity: isOpportunity,
                        recordType: recordType,
                        recordId: recordId,
                        isShowroomStock: isShowroomStock,
                        internalVehicleNumber: internalVehicleNumber

                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.messageemail) {
                            $('.invalid-email-error').text(data.messageemail);
                        } else if (data.result.error) {
                           $.spinner().stop();
                            var reason = null;
                            try { reason = typeof data.result.reason === 'string' ? JSON.parse(data.result.reason) : (data.result.reason || null); } catch (e) { }
                            var errorMessage = 'This opportunity already has a configuration.';
                            var functionalErrorMessage = 'There is an issue with configuration update, please close the tab and update the order again from CXP';
                            var incompatibleAccessoriesMessage = 'The configuration is invalid due to incompatible accessories. Please restart from CXP portal.';
                            if (reason && reason.message == errorMessage) {
                                $(configuratorCtas.CXP).addClass('disabled');
                                $('#configuration-already-saved-modal').modal('show');
                            } else if (reason && reason.message == functionalErrorMessage) {
                                window.ecux.notify(reason.message, '', 'warning');
                            } else if (reason && reason.message == incompatibleAccessoriesMessage) {
                                window.ecux.notify(reason.message, '', 'warning');
                            } else {
                                window.ecux.notify($('.offline-order-error-message').val(), '', 'warning');
                            }
                        } else {
                            $('.invalid-email-error').empty();
                            $.spinner().stop();
                            $('#configurator-save-and-share-modal').modal('hide');
                            var newMsg = `Build ${data.code || ''} successfully saved to CXP. Please close this tab as no further changes can be made.`;
                            ecux.notify(newMsg, '');
                            $(configuratorCtas.CXP).addClass('cxp-success disabled');
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                        window.ecux.notify($('.offline-order-error-message').val(), '', 'warning');
                    },
                    complete: function () {
                        if (IS_TAB_ISOLATION) {
                            saveExecutionGate.completeSaveGateAction('.configurator-send-offine-order-cta');
                        }

                        if (!$(configuratorCtas.CXP_HOOK).hasClass('cxp-success')) {
                            configuratorCtas.syncCxpHookEnabled();
                            configuratorCtas.reapplyOrderNowDisabled();
                            saveToCxpGate.reapplyNavCta();
                        }
                    }
                });
            });

            $('#laod-previous-build-cta').on('click', () => {
                $('#selectCarModal').modal('hide');
                setTimeout(() => $('#configurator-load-a-build-modal').modal('show'), 5);
            });

            $('#load-my-build-cta').on('click', () => {
                var $uniqueCodeLen = $('#build-unique-code').val().replace(/\s/g, '').length;
                if ($uniqueCodeLen != 6) {
                    $('.unique-code-invalid-feedback').addClass('d-flex').removeClass('d-none');
                    $('#build-unique-code-input').addClass('unique-code-input-error');
                } else {
                    var modalContent = $('#configurator-load-a-build-modal .modal-content');
                    var url = $('#configurator-load-a-build-modal').data('action');
                    var uniqueBuildId = $('#build-unique-code').val();
                    var formData = {
                        uniqueBuildId: uniqueBuildId
                    }
                    modalContent.spinner().start();
                    $.ajax({
                        url: url,
                        type: 'post',
                        dataType: 'json',
                        data: formData,
                        success: function (response) {
                            modalContent.spinner().stop();
                            if (response.result.success) {
                                window.location.href = response.redirectURL;
                            } else {
                                $('.unique-code-invalid-feedback').addClass('d-flex').removeClass('d-none');
                                $('#build-unique-code-input').addClass('unique-code-input-error');
                            }
                        },
                        error: function () {
                            modalContent.spinner().stop();
                            $('.unique-code-invalid-feedback').addClass('d-flex').removeClass('d-none');
                            $('#build-unique-code-input').addClass('unique-code-input-error');
                        }
                    });
                }
            });

            var promotionSliderConfig = {
                "dots": true,
                "infinite": false,
                "arrows": true,
                "variableWidth": false,
                "slidesToScroll": 1,
                "prevArrow": `<button type="button" class="slick-prev"><div class="icon icon-angle-left"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Size=L, Fill=Off, Direction=West"><path id="Union" d="M28.05 36.6785L15.3215 23.95L28.05 11.2215L30.8785 14.05L20.9785 23.95L30.8785 33.85L28.05 36.6785Z" fill="#0A0A0A"></path></g></svg></div></button>`,
                "nextArrow": `<button type="button" class="slick-next"><div class="icon icon-angle-right"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Size=L, Fill=Off, Direction=East"><path id="Union" d="M25.8215 23.95L15.9215 14.05L18.75 11.2215L31.4785 23.95L18.75 36.6785L15.9215 33.85L25.8215 23.95Z" fill="#0A0A0A"></path></g></svg></div></button>`,
                "responsive": [{
                    "breakpoint": 1024,
                    "settings": {
                        "slidesToShow": 4.2
                    }
                },
                {
                    "breakpoint": 440,
                    "settings": {
                        "slidesToShow": 3.2
                    }
                }
                ]
            }

            $('#configurator-promotion-slider').slick(promotionSliderConfig);

            $('#configurator-save-and-share #details-form-email').on('input', function () {
                $('#configurator-save-and-share .invalid-email-error').hide();
                $(this).removeClass('is-invalid');
            })

            $('#configurator-save-and-share #details-form-phone').on('input', function () {
                const errorElement = $('#configurator-save-and-share #details-form-phone-error');
                errorElement.hide();
                $(this).removeClass('is-invalid');
            });

            $('.modify-order-cancel-button').on('click', (e) => {
                e.preventDefault();
                $('#configurator-modify-car-cancel-modal').modal('show');
            })

            $(document).on('click', '.footer-location-postcode-message', (e) => {
                e.preventDefault();
                e.stopPropagation();
                $('#postcode-restricted-modal').modal('show');
            });

            $(document).on('click', '.postcode-restrict-modal-close', (e) => {
                e.preventDefault();
                $('#postcode-restricted-modal').modal('hide');
            });

            $('.modify-car-summary-update-order-cta').on('click', (e) => {
                e.preventDefault();

                if ($(e.currentTarget).hasClass('disabled')) {
                    return;
                }

                // Change VIN with no VIN allocated moves the order to UBO; tell the dealer before they confirm
                var isChangeVin = new URLSearchParams(window.location.search).get('action') === 'changeVIN';
                var hasNewVin = !!$('.internal-Vehicle-number').find('input[name="internalVehicleNumber"]').attr('value');
                $('#configurator-modify-car-update-modal .changevin-ubo-note').toggleClass('d-none', !(isChangeVin && !hasNewVin));

                $('#configurator-modify-car-update-modal').modal('show');
            })

            $('.grade-option-js').on('click', function () {
                var selectedVarient = $(this).data('attr-value');
                $('.car-color-varient').text(selectedVarient);
            });

            if (orderId && action !== 'Changeconfigurationtonewoffer' && action !== 'changeVIN') {
                var purchasedVariant = sessionStorage.getItem('modifySelectedOrderVariant') !== null ? JSON.parse(sessionStorage.getItem('modifySelectedOrderVariant')) : '';
                var currentUrl = new URL(window.location.href);
                var carModel = currentUrl.pathname.split('/').pop().split('.')[0];
                if (carModel == purchasedVariant.carModel) {
                    $('#attribute-color .color-attribute').each(function () {
                        if (purchasedVariant && $(this).data('value') == purchasedVariant.variantColor) {
                            var carColor = $(this).data('color');
                            var textCapitalize = carColor.toLowerCase().replace(/./, (x) => x.toUpperCase()).replace(/[^']\b\w/g, (y) => y.toUpperCase());
                            var spanHTML = '<span class="modify-car-protected-price-text text-xxs font-light text-left d-block">' + 'Price protected for ' + '<span class="protected-price-text-car-color">' + textCapitalize + ' only.</span></span>';
                            $('.grade-attribute input[data-attr-value]').each(function () {
                                if ($(this).data('attr-value') === purchasedVariant.variant) {
                                    var label = $(this).siblings('label');
                                    if (label.length) {
                                        label.after(spanHTML);
                                    }
                                }
                            });
                            $(this).addClass('modify-order-ordered-value');
                        }
                    });
                }
            }

            $('#modify-car-update-button').on('click', () => {
                var $updateOrderCta = $('.modify-car-summary-update-order-cta');

                if (IS_TAB_ISOLATION && !saveExecutionGate.beginSaveGateAction($updateOrderCta, '#modify-car-update-button')) {
                    return;
                }

                var modifyCarConfirmModal = $('#configurator-modify-car-update-modal');
                var url = modifyCarConfirmModal.data('action');
                var params = new URLSearchParams(window.location.search);
                var orderId = params.get('orderId') || '';
                var modifyAccessories = params.get('modifyAccessories') || '';
                var modifyCar = params.get('modifyCar') || '';
                var modalContent = $('#configurator-modify-car-update-modal .modal-content');
                var showroomStock = params.get('showroomStock') || '';
                var userId = params.get('userId') || '';
                var sessionId = params.get('sessionId') || '';
                var camp = params.get('camp') || '';
                var action = params.get('action') || '';
                var newVIN = action === 'changeVIN'
                    ? ($('.internal-Vehicle-number').find('input[name="internalVehicleNumber"]').attr('value') || '')
                    : '';
                $('.modify-car-summary-update-order-cta').addClass('disabled');
                modalContent.spinner().start();
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    data: {
                        orderId: orderId,
                        modifyAccessories: modifyAccessories,
                        modifyCar: modifyCar,
                        showroomStock: showroomStock,
                        userId: userId,
                        sessionId: sessionId,
                        camp: camp,
                        action: action,
                        newVIN: newVIN
                    },
                    success: function (response) {
                        modifyCarConfirmModal.modal('hide');
                        modalContent.spinner().stop();
                        var incompatibleAccessoriesMessage = 'The configuration is invalid due to incompatible accessories. Please restart from CXP portal.';
                        if (response.success) {
                            sessionStorage.removeItem('modifySelectedOrderVariant');
                            if (response.success && response.gtmEventData) {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push(response.gtmEventData);
                            }
                            $('.modify-car-summary-update-order-cta').addClass('cxp-success');

                            // Delay redirect to ensure GTM gets pushed
                            setTimeout(() => {
                                if (response.successMsg) {
                                    modifyCarConfirmModal.modal('hide');
                                    ecux.notify(response.successMsg, '');
                                } else {
                                    window.location.href = response.redirectURL;
                                }
                            }, 100);
                        } else if (!response.success && response.message) {
                            window.ecux.notify(response.message, '', 'warning');
                        } else if (!response.success && response.message == incompatibleAccessoriesMessage) {
                            window.ecux.notify(response.message, '', 'warning');
                        } else if (!response.success && response.orderUnchangedError) {
                            $('.order-unchanged-error').removeClass('d-none').fadeIn();
                            setTimeout(function () {
                                $('.order-unchanged-error').fadeOut(
                                    function () {
                                        $(this).addClass('d-none');
                                    }
                                );
                            }, 100);
                        } else {
                            window.ecux.notify($('.offline-order-error-message').val(), '', 'warning');
                        }
                    },
                    complete: function () {
                        if (IS_TAB_ISOLATION) {
                            saveExecutionGate.completeSaveGateAction('.modify-car-summary-update-order-cta');
                        }
                    }
                });
            });

            // Footer / summary "Book a test drive" CTAs open the redesigned flyout (view="test-drive")
            // instead of the legacy modal. These CTAs live outside the flyout `triggerScope`
            // (`.configurator-navigation`), so drive the flyout directly via its exposed `setView` API.
            $('.configurator-footer-actions-test-drive').on('click', function () {
                var $btn = $(this);
                var flyout = document.querySelector('.configurator-modal');

                if ($btn.hasClass('d-none') || $btn.hasClass('disabled') || $btn.prop('disabled')) {
                    return;
                }

                if (flyout && typeof flyout.setView === 'function') {
                    flyout.setView('test-drive');
                    $(flyout).modal('show');
                }
            });

            // Legacy test-drive modal submit/validation handlers removed: the footer/summary CTAs now
            // open the redesigned flyout (view="test-drive"), which owns lead submission, validation
            // and GTM events (see navigation/testDriveDetails.js). The old modal markup + form have
            // been removed from configuratorPageFooter.isml.

            $('#configurator-footer-actions-summary').on('click', function () {
                if ($(this).hasClass('disabled') || $(this).prop('disabled')) {
                    return;
                }

                // stock label logic
                if ($(this).hasClass('stocklabel-outofstock')) {
                    if ($(this).hasClass('show_grade_outofstock_label')) {
                        $('#goutofstockmodal').modal('show');
                    } else {
                        $('#coutofstockmodal').modal('show');
                    }
                    return;
                }
                // end stock label logic

                const params = new URLSearchParams(window.location.search);
                const shouldShow = params.get("showSummary");
                if (shouldShow === "true" || !$(this).is('.duplicate-tab-blocker')) {
                    if (shouldShow === "true") {
                        $('.add-to-cart-global').trigger('click');
                        $('#configuratorSummary-tab').removeAttr('disabled');
                        $('#configuratorSummary-tab').removeClass('disabled');
                        $('#configuratorSummary-tab').trigger('click');
                        configurator.updateStage('summary');
                    } else {
                        frontendUtils.updateUrlParams({ 'showSummary': 'true' });
                        $('body').spinner().start();
                        window.location.reload();
                    }
                } else {
                    if ($('.toast-container').length > 0) {
                        window.ecux.notify("We are unable to proceed with your request as there is an existing order open in another window. Please close the other window and try again.");
                    }
                }
            });

            $('#configurator-footer-actions-summary-m, #configurator-footer-actions-summary').on('click', () => {
                syncUpsellCampaignUX();
            });

            $('#configurator-footer-actions-summary-m').on('click', function () {
                if ($(this).hasClass('disabled') || $(this).prop('disabled')) {
                    return;
                }

                // stock label logic
                if ($(this).hasClass('stocklabel-outofstock')) {
                    if ($(this).hasClass('show_grade_outofstock_label')) {
                        $('#goutofstockmodal').modal('show');
                    } else {
                        $('#coutofstockmodal').modal('show');
                    }
                    return;
                }
                // end stock label logic

                const summaryStage = singleTabConfigurator.isSummaryStage();
                if (summaryStage || !$(this).is('.duplicate-tab-blocker')) {
                    if (summaryStage) {
                        $('.add-to-cart-global').trigger('click');
                        $('#configuratorSummary-tab-m').trigger('click');
                        configurator.updateStage('summary');
                    } else {
                        frontendUtils.updateUrlParams({ 'showSummary': 'true' });
                        $('body').spinner().start();
                        window.location.reload();
                    }
                } else {
                    if (FEATURES.singleTabConfigurator) {
                        singleTabConfigurator.showBlockedNotification();
                    }
                }
            });

            $('.weekly-interest-disclaimer-cta').on('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                $('#product-finance-modal-info, #customize-page-product-finance-modal-info')
                    .modal('hide')
                    .one('hidden.bs.modal', (event) => {
                        $('#weekly-interest-disclaimer-modal')
                            .attr('data-origin-modal', event.target.id)
                            .modal('show')
                        ;
                    })
                ;
            });

            $('#weekly-interest-disclaimer-modal').on('hidden.bs.modal', (event) => {
                const { originModal } = event.target.dataset;

                if (originModal) {
                    delete event.target.dataset.originModal;

                    $(`#${originModal}`).modal('show');
                }
            });
        },
    },
    // buildLoadedToast: function () {
    //     var $toast = $('#build-loaded-toast');
    //     if (!$toast.length) return;

    //     var AUTO_DISMISS_MS = 8000;
    //     var HIDE_ANIMATION_MS = 200;
    //     var dismissTimer = null;

    //     function hideToast() {
    //         if (dismissTimer) {
    //             clearTimeout(dismissTimer);
    //             dismissTimer = null;
    //         }

    //         $toast.addClass('is-hiding');
    //         setTimeout(function () {
    //             $toast.removeClass('is-hiding').addClass('d-none');
    //         }, HIDE_ANIMATION_MS);
    //     }

    //     $toast.on('click', '.build-loaded-toast__close', hideToast);

    //     var shouldShow = false;
    //     try {
    //         shouldShow = sessionStorage.getItem('buildLoadedToastPending') === '1';
    //         if (shouldShow) {
    //             sessionStorage.removeItem('buildLoadedToastPending');
    //         }
    //     } catch (e) { /* storage unavailable */ }

    //     if (!shouldShow) return;

    //     $toast.removeClass('d-none is-hiding');
    //     dismissTimer = setTimeout(hideToast, AUTO_DISMISS_MS);
    // },
    __uniqueCodeInputFill: function (containerSelector, hiddenInputName) {
        containerSelector = containerSelector || "#build-unique-code-input";
        hiddenInputName = hiddenInputName || "build-unique-code";

        const container = document.querySelector(containerSelector);
        if (!container) return;

        const inputs = container.querySelectorAll("input[type=text]");
        const hiddenInput = document.querySelector("input[name=" + hiddenInputName + "]");

        for (let i = 0; i < inputs.length; i++) {
            const input = inputs[i];
            input.addEventListener("input", function () {

                if (input.value.length == 1 && i + 1 < inputs.length) {
                    inputs[i + 1].focus();
                }
                if (input.value.length > 1) {
                    const chars = input.value.split('');

                    for (let pos = 0; pos < chars.length; pos++) {
                        if (pos + i >= inputs.length) break;
                        let targetInput = inputs[pos + i];
                        targetInput.value = chars[pos];
                    }

                    let focus_index = Math.min(inputs.length - 1, i + chars.length);
                    inputs[focus_index].focus();
                }
                updateInput();
            });

            input.addEventListener("keydown", function (e) {
                if (e.keyCode == 8 && input.value == '' && i != 0) {
                    for (let pos = i; pos < inputs.length - 1; pos++) {
                        inputs[pos].value = inputs[pos + 1].value;
                    }

                    inputs[i - 1].value = '';
                    inputs[i - 1].focus();
                    updateInput();
                    return;
                }

                if (e.keyCode == 46 && i != inputs.length - 1) {
                    for (let pos = i; pos < inputs.length - 1; pos++) {
                        inputs[pos].value = inputs[pos + 1].value;
                    }

                    inputs[inputs.length - 1].value = '';
                    input.select();
                    e.preventDefault();
                    updateInput();
                    return;
                }

                if (e.keyCode == 37) {
                    if (i > 0) {
                        e.preventDefault();
                        inputs[i - 1].focus();
                        inputs[i - 1].select();
                    }
                    return;
                }

                if (e.keyCode == 39) {
                    if (i + 1 < inputs.length) {
                        e.preventDefault();
                        inputs[i + 1].focus();
                        inputs[i + 1].select();
                    }
                    return;
                }
            });
        }

        function updateInput() {
            let inputValue = Array.from(inputs).reduce(function (otp, input) {
                otp += (input.value.length) ? input.value : ' ';
                return otp;
            }, "");
            if (hiddenInput) {
                hiddenInput.value = inputValue;
            }
        }
    },
    header: {
        initMobileNavigation: function () {
            $('.configurator-mobile-nav').on('click', function () {
                $(`#${$(this).attr('id').split('-m')[0]}`).trigger('click');
            });
        },
        populateDriveAwayPrice: function () {
            let $headerDriveAwayPrice = $('.configurator-header-drive-away-price');
            let $configuratorFooterDriveAwayPriceMobile = $('#configurator-footer-drive-away-price-m');
            let $summaryButton = $(configuratorCtas.BUILD);
            let $weeklyPaymentDetails = $('.weekly-payment-details');

            $('body').on('product:beforeAttributeSelect', function () {
                var $navbarHeaderSummary = $('#navbar-header-summary');
                if ($navbarHeaderSummary.hasClass('show')) {
                    $navbarHeaderSummary.addClass('opacity-50');
                }

                $configuratorFooterDriveAwayPriceMobile.addClass('opacity-50');
                $weeklyPaymentDetails.addClass('opacity-50');
                $summaryButton.addClass('disabled');
            });

            $('body').on('product:afterAttributeSelect', function (el, response) {
                if (response.data.product.productType !== "master") {
                    configurator.header.updateDriveAwayPrice({ pid: response.data.product.id, updatePrice: true });
                } else {
                    $headerDriveAwayPrice.html(`<div class="skeleton skeleton-md"></div>`);
                    $configuratorFooterDriveAwayPriceMobile.removeClass('opacity-50');
                    $weeklyPaymentDetails.removeClass('opacity-50');
                    $summaryButton.addClass('disabled');
                }
            });
        },
        initHeadersEvents: function () {
            var $headerConfiguratorOrderTab = $('#configuratorOrder-tab');
            var $navbarHeaderSummary = $('#navbar-header-summary');

            $('#configuratorConfigure-tab').on('click', function () {
                configurator.updateStage('configure');
                $headerConfiguratorOrderTab.addClass('disabled');
                $('#configurator-footer-actions-summary').removeClass('d-none');

                var ineligible = configuratorStageConfigure.lastIneligible;

                if (ineligible == null) {
                    ineligible = $('.configurator-navigation .btn-test-drive[aria-disabled="true"]').length > 0;
                }

                configuratorStageConfigure.handleTestDriveVisibility(ineligible);

                $('#configurator-footer-actions-save').removeClass('d-none');
                $(configuratorCtas.CXP).removeClass('d-flex').addClass('d-none');
                $('.modify-car-summary-update-order-cta').removeClass('d-flex').addClass('d-none');
                $('.configuratorConfigure-tab-m').addClass('active');
                $('.configuratorSummary-tab-m').removeClass('active');
                // Configure stage: next goes to Summary, which is always reachable.
                $('#summary-next').removeClass('d-none');

                if (!configurator.isOnlineOrderingUiEnabled()) {
                    $('.configurator-footer-actions-test-drive').each(function () {
                        var $btn = $(this);
                        if ($btn.hasClass('btn-primary')) {
                            $btn.removeClass('btn-primary').addClass('btn-secondary');
                        }
                        $btn.find('white').each(function () {
                            $(this).removeClass('white').addClass('color--nutral-90');
                        });
                    });
                }
            });

            $('#configuratorSummary-tab').on('click', function () {
                configurator.updateStage('summary');
                if (window.innerWidth < commonOptions.breakpoints.sm) {
                    $('#configurator-footer-actions-test-drive').addClass('d-none');
                    $('#configurator-footer-actions-save').addClass('d-none');
                }
                $('#configurator-footer-actions-summary').addClass('d-none');
                $('#configurator-footer-actions-summary-m').addClass('d-none');
                var params = new URLSearchParams(window.location.search);
                var recordID = params.get('recordId') || '';
                var recordType = params.get('relatedRecordType') || '';
                var userId = params.get('userId') || '';
                var sessionId = params.get('sessionId') || '';
                var modifyCar = params.get('modifyCar') || '';
                var modifyAccessories = params.get('modifyAccessories') || '';
                var orderId = params.get('orderId') || '';
                var action = params.get('action') || '';
                if ((recordID || recordType || userId || sessionId) && !orderId) {
                    $(configuratorCtas.CXP).removeClass('d-none');
                } else if ((modifyCar && orderId) || (modifyAccessories && orderId) || (action === 'Changeconfigurationtonewoffer' && orderId) || (action === 'changeVIN' && orderId)) {
                    $('.modify-car-summary-update-order-cta').removeClass('d-none');
                } else if (configurator.isOnlineOrderingUiEnabled()) {
                    $('#configurator-footer-actions-checkout').removeClass('d-none');
                }
                $headerConfiguratorOrderTab.removeClass('disabled');
                $('#summary-next').toggleClass('d-none', $headerConfiguratorOrderTab.hasClass('d-none'));
                $('.configuratorSummary-tab-m').addClass('active');
                $('.configuratorConfigure-tab-m').removeClass('active');
            });

            $('body').on('configurator:stageUpdate:configure', function () {
                $navbarHeaderSummary.addClass('d-md-flex');
            });

            $('body').on('product:beforeAddToCart', function () {
                $headerConfiguratorOrderTab.addClass('disabled');
            });

            $('body').on('product:afterAddToCart', function () {
                $headerConfiguratorOrderTab.removeClass('disabled');
            });
        },
        updateDriveAwayPrice: function (paramsConfig) {
            var params = new URLSearchParams(window.location.search);
            var showSummary = params.get('showSummary') || '';
            if (showSummary) {
                $('#navbar-header-summary').addClass('show');
                return;
            }
            var config = paramsConfig || {};
            var $configuratorHeaderDriveAwayPrice = $('.configurator-header-drive-away-price');
            let $configuratorFooterDriveAwayPriceMobile = $('#configurator-footer-drive-away-price-m');
            var $navbarHeaderSummary = $('#navbar-header-summary');
            let $currentProduct = $('#current-product');
            var orderId = params.get('orderId') || '';
            var action = params.get('action') || '';
            var crossBorderDelivery = params.get('crossBorderDelivery') || '';
            let $summaryButton = $(configuratorCtas.BUILD);
            let $weeklyPaymentDetails = $('.weekly-payment-details');

            var accessoryActionFromFlyout = $('#accessory-details-flyout').data('actionFromFlyout');
            $('#accessory-details-flyout').removeData('actionFromFlyout');
            var $accessoryActionSpinner = accessoryActionFromFlyout
                ? $('#accessory-details-flyout .modal-content')
                : $(`#rCard-${config.addToTile}`);

            if (config.addToTile && $accessoryActionSpinner.length) {
                $accessoryActionSpinner.spinner().start();
            }

            if ($navbarHeaderSummary.hasClass('show')) {
                $navbarHeaderSummary.addClass('opacity-50');
            }

            $.ajax({
                url: dwService.url('Product-getDriveAwayPrice'),
                type: 'get',
                dataType: 'json',
                data: {
                    pid: config.pid ? config.pid : $currentProduct.data('selectedvariationid'),
                    orderId: orderId,
                    action: action,
                    crossBorderDelivery: crossBorderDelivery
                },
                success: function (data) {
                    var formattedDriveAwayPrice = frontendUtils.formatToAUDollar(data.driveAwayPrice);
                    var formattedDriveAwayPrice = formattedDriveAwayPrice + '*';
                    var params = new URLSearchParams(window.location.search);
                    var flags;
                    var isUpdateOrder;
                    var addonDetail = document.querySelector('.region--addon-detail');

                    $configuratorHeaderDriveAwayPrice.html(formattedDriveAwayPrice);
                    $configuratorFooterDriveAwayPriceMobile.html(formattedDriveAwayPrice);

                    document.querySelector('.summary-item.drive-away .value').textContent = formattedDriveAwayPrice;

                    if (addonDetail) {
                        addonDetail.classList.remove('d-none');
                        addonDetail.classList.add('fade-in');
                    }

                    if (formattedDriveAwayPrice) {
                        flags = buildCTAEvaluator.getFlags();
                        isUpdateOrder = !!(params.get('orderId') || params.get('modifyCar') || params.get('modifyAccessories') || params.get('action') === 'Changeconfigurationtonewoffer');

                        if (!flags || flags.showBuildCTA !== false || isUpdateOrder) {
                            $summaryButton.removeClass('disabled');
                        }
                    }

                    if (FEATURES.configuratorRecommendation) {
                        config.accessoriesRecTypeCount = data.accessoriesRecTypeCount;
                        configuratorRecommendation.afterAddReccomendationProductToList(config);
                    }

                    if (config && config.isSummarySection) {
                        window.configurator.stage.summary.updateSummaryData();
                        $('#configurator-summary-accessories').removeAttr('data-hx-revealed');
                    }

                    if (data.totalsItems > 0) {
                        updateAccessoriesURLParameters(data.listItems);
                    } else {
                        frontendUtils.deleteUrlParams('accpk,acc,mem');
                    }

                    configuratorStageSummary.updateFinanceComponent(data.finance);

                    if (config.addToTile && $accessoryActionSpinner.length) {
                        $accessoryActionSpinner.spinner().stop();
                    }

                    if ($navbarHeaderSummary.hasClass('show')) {
                        $navbarHeaderSummary.removeClass('opacity-50');
                    } else {
                        $navbarHeaderSummary.addClass('show');
                    }

                    if ($navbarHeaderSummary.hasClass('show')) {
                        $navbarHeaderSummary.removeClass('opacity-50');
                    } else {
                        $navbarHeaderSummary.addClass('show');
                    }

                    if ($weeklyPaymentDetails.hasClass('opacity-50')) {
                        $weeklyPaymentDetails.removeClass('opacity-50');
                    }

                    if ($configuratorFooterDriveAwayPriceMobile.hasClass('opacity-50')) {
                        $configuratorFooterDriveAwayPriceMobile.removeClass('opacity-50');
                    }
                }
            });
        }
    },
    stage: {
        configure: {
            setupTemplateLoaders: function () {
                $.spinner().start();
                $('#variation-based-slot__recommendation').spinner().start({ filled: true });
            },
            attributeSelect: function () {
                let updateNoTabsImages = this.updateNoTabsImages;
                let updateTabsImages = this.updateTabsImages;
                let handleStackedModals = this.handleStackedModals;
                let updateKeySpecifications = this.updateKeySpecifications;
                let updatePromotionalTiles = this.updatePromotionalTiles;
                let updateWarrantyExtras = this.updateWarrantyExtras;
                let updateOffers = this.updateOffers;
                let updateGradeOfferPills = this.updateGradeOfferPills;
                let refreshRecommendationCarousels = this.refreshRecommendationCarousels;
                let updateGradeAttrData = this.updateGradeAttrData;
                let updateModifyOrderColorLock = this.updateModifyOrderColorLock;
                let triggerStockLabelEvent = this.triggerStockLabelEvent;
                let removeParamsFromUrl = this.removeParamsFromUrl;
                let $footerDealerAvailability = $('#configurator-footer-dealer-availability');
                let $configuratorSummaryDealerAvailability = $('#configurator-summary-dealer-availability');
                let $navbarDealerAvailability = $('#configurator-navbar-dealer-availability');
                let $navbarAvailabilityItem = $('.region--addon-detail .summary-item.availability');
                // The availability flyout reuses the same `is-<state>` class mechanic so a
                // CSS toggle is enough to swap between the orderable and lowstock layouts.
                let $availabilityFlyout = $('.modal-view--availability');
                let $availabilityFlyoutLabel = $('#availability-flyout-state-label');
                let $availabilityFlyoutSubtitle = $('#availability-flyout-subtitle');
                let $availabilityFlyoutOrderOnline = $('#availability-flyout-order-online');

                // Rewrite the Order online href to the live configurator URL + `showSummary=true`.
                // Done client-side (rather than as a server-rendered `URLUtils.url(...)`) because
                // AJAX attribute selects rewrite `window.location` via `frontendUtils.updateUrlParams`
                // (pushState), and we want the link target to stay in lock-step with whichever
                // grade / colour / dealer the user has on screen — including for right-click /
                // middle-click "open in new tab".
                function syncAvailabilityOrderOnlineHref() {
                    if (!$availabilityFlyoutOrderOnline.length) return;
                    try {
                        var url = new URL(window.location.href);
                        url.searchParams.set('showSummary', 'true');
                        // Drop any leftover `#` from the placeholder href so the navigated URL is clean.
                        url.hash = '';
                        $availabilityFlyoutOrderOnline.attr('href', url.toString());
                    } catch (err) {
                        // Bad URL (very unlikely) — leave the placeholder href in place so the
                        // browser at least no-ops instead of throwing.
                    }
                }
                syncAvailabilityOrderOnlineHref();

                // Click-time safety net: re-sync the href just before the browser performs the
                // navigation, so even if some upstream code rewrote `window.location` without
                // firing `product:afterAttributeSelect`, the navigation still lands on the user's
                // current build. We don't `preventDefault`, so this remains a native link click
                // (right-click / middle-click etc. all still work).
                $availabilityFlyoutOrderOnline.on('click', function () {
                    syncAvailabilityOrderOnlineHref();
                });
                let $confirmCalenderIcon = $('.dealer-availability-celender-icon');
                let $selectGradeMobileBtnPrice = $('#select-grade-m-btn-price');
                let $selectGradeMobileBtnLabel = $('#select-grade-m-btn-label');
                let $currentProduct = $('#current-product');
                var $mobileDriveAwayPrice = '';

                $('body').on('product:beforeAttributeSelect', function () {
                    $footerDealerAvailability.addClass('show');
                    $footerDealerAvailability.addClass('opacity-50');
                    $configuratorSummaryDealerAvailability.html(`<div class="skeleton skeleton-sm px-5"></div>`);
                    $navbarDealerAvailability.addClass('opacity-50');
                    $('.configurator-variation-promotions').removeClass('show');
                    $('#variation-based-slot__recommendation').spinner().start({ filled: true });
                    $('.variation-base_slots').children().spinner().start({ filled: true });
                    $('#variation-based-slot__recommendation .variation-based-slot__recommendation-content').removeClass('show');
                });

                $('body').on('htmx:afterSettle shown.bs.modal', function () {
                    $('.back-to-pack-btn').each(function () {
                        if ($(this).closest('.pack-component-modal').length > 0) {
                            $(this).text('Back to pack');
                        } else {
                            $(this).text('Go Back');
                        }
                    });
                });

                // Flag to track actual user clicks on grade selector (not programmatic triggers)
                var userClickedGrade = false;

                // Set flag when user physically clicks on grade selector
                $(document).on('click', '.grade-option-js', function (e) {
                    // Only set flag for real user clicks (not programmatic triggers)
                    if (e.originalEvent) {
                        userClickedGrade = true;
                    }
                });

                $('body').on('product:afterAttributeSelect', function (el, response) {
                    if (response.data && typeof response.data.isOnlineOrderingEnabled !== 'undefined') {
                        configurator.syncOnlineOrderingCTAs(response.data.isOnlineOrderingEnabled);
                    }

                    // GA tracking for grade selection - only fire on actual user click, not programmatic triggers
                    try {
                        var selectedGrade = response.data.product.customProps.grade;
                        // Only push to dataLayer if this was triggered by an actual user click
                        if (selectedGrade && userClickedGrade) {
                            var urlParams = new URLSearchParams(window.location.search);
                            var campaignParam = urlParams.get('camp') || '';
                            var campaignIds = campaignParam ? campaignParam.split('&') : [];

                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'configurator_grade_select_click',

                                action: 'click',
                                event_type: 'click',
                                content_type: 'configurator',
                                context: 'grade_selector',
                                'location.onpage': 'grade_selection',

                                model_id: response.data.product.id || null,
                                ui_experience: 'configurator',

                                site_session_id: $('.page').data('session-id') || null,
                                timestamp_unix: Math.floor(Date.now() / 1000),

                                suburb: urlParams.get('suburb') || null,
                                postcode: urlParams.get('pc') || null,
                                state: urlParams.get('state') || null,
                                campaign_ids: campaignIds.length > 0 ? campaignIds : null
                            });
                        }
                        // Reset flag after processing
                        userClickedGrade = false;
                    } catch (gaError) {
                        console.error('GA tracking error:', gaError);
                    }

                    const dataCarSummaryData = {
                        data: {
                            product: response.data.product
                        }
                    };
                    delete dataCarSummaryData.data.product.longDescription;
                    delete dataCarSummaryData.data.product.promotionsHtml;
                    $('.js-save-summary').attr('data-car-summary-data', JSON.stringify(dataCarSummaryData));

                    try {

                        // if (window.innerWidth < commonOptions.breakpoints.md) {
                        //     const carImage = response.data.product.images.large[0].url;
                        //     const carImageElement = document.querySelector('.car-background-color img');
                        //     carImageElement.setAttribute('src', carImage);

                        //     const span = document.querySelector('span.color-value.selected');
                        //     if (span) {
                        //         const bgColor = window.getComputedStyle(span).backgroundColor;
                        //         const carBackgroundElement = document.querySelector('.car-background-color');
                        //         carBackgroundElement.style.backgroundColor = bgColor;
                        //         updateCarImageSummaryPage(carImage, bgColor);
                        //         updateSummaryButtonColor();
                        //     }
                        // }

                        $currentProduct.attr('data-selectedvariationid', response.data.product.id);
                        $currentProduct.data('selectedvariationid', response.data.product.id);

                        $currentProduct.attr('data-producttype', response.data.product.productType);
                        $currentProduct.data('producttype', response.data.product.productType);
                        if (response.data.product.updatedColorBasedPrice) {
                            $('.grade-option-js:checked').parent('.radio-cards__card').find('.variation-grade__price').text(frontendUtils.formatToAUDollar(
                                response.data.product.updatedColorBasedPrice
                            ) + '*');
                        } else if (response.data.product.customProps.BasePrice) {
                            $('.grade-option-js:checked').parent('.radio-cards__card').find('.variation-grade__price').remove('.skeleton').text(frontendUtils.formatToAUDollar(
                                response.data.product.customProps.BasePrice
                            ) + '*');
                        }

                        if (response.data.product.customProps.grade && response.data.product.customProps.BasePrice) {
                            $selectGradeMobileBtnLabel.html(response.data.product.customProps.GradeDesc);
                            $mobileDriveAwayPrice = frontendUtils.formatToAUDollar(response.data.product.customProps.BasePrice);
                            $selectGradeMobileBtnPrice.html("from " + $mobileDriveAwayPrice + "*");
                        }

                        if (!response.data.accessoriesRecommendationCount) {
                            $('.product-recommendations-accessories-js').addClass('d-none');
                        } else {
                            $('.product-recommendations-accessories-js').removeClass('d-none');
                        }
                        var productAvailabilityData = response.data.productAvailabilityMessage;
                        if (productAvailabilityData) {
                            $footerDealerAvailability.html(productAvailabilityData.message);
                            if (productAvailabilityData.message) {
                                $confirmCalenderIcon.removeClass('d-none');
                            }
                            $configuratorSummaryDealerAvailability.html(productAvailabilityData.message);

                            // Navbar shows a short label keyed off `stockState` (instock | onwater |
                            // onorder | lowstock | limitedstock). On water and On order override the
                            // static resource with the month range from the server.
                            var stockState = productAvailabilityData.stockState || '';
                            var navbarLabel = productAvailabilityData.navbarLabel
                                || (stockState ? ($navbarDealerAvailability.data('label-' + stockState) || '') : '');
                            $navbarDealerAvailability.text(navbarLabel);
                            $navbarAvailabilityItem
                                .removeClass('is-instock is-onwater is-onorder is-lowstock is-limitedstock');
                            if (stockState) {
                                $navbarAvailabilityItem.addClass('is-' + stockState);
                            }

                            // Keep the availability flyout (.modal-view--availability) in sync so
                            // an already-open flyout — or one opened immediately after — reflects
                            // the latest attribute selection. We mirror the navbar's class toggle;
                            // On water and On order use the full "Available May/Jun" title with an
                            // empty subtitle; UBO/limited-stock swap in their resource subtitles.
                            if ($availabilityFlyout.length) {
                                $availabilityFlyout
                                    .removeClass('is-instock is-onwater is-onorder is-lowstock is-limitedstock');
                                $availabilityFlyout.find('.availability-content__message').addClass('d-none');
                                if (stockState) {
                                    $availabilityFlyout.addClass('is-' + stockState);
                                    $availabilityFlyout.find('.availability-content__message.is-' + stockState).removeClass('d-none');
                                }
                                var flyoutTitle = productAvailabilityData.flyoutTitle
                                    || (stockState ? ($availabilityFlyoutLabel.data('label-' + stockState) || '') : '');
                                $availabilityFlyoutLabel.text(flyoutTitle);
                                if (stockState === 'onwater' || stockState === 'onorder') {
                                    $availabilityFlyoutSubtitle.text(
                                        productAvailabilityData.flyoutSubtitle != null
                                            ? productAvailabilityData.flyoutSubtitle
                                            : ''
                                    );
                                } else if (stockState === 'lowstock') {
                                    $availabilityFlyoutSubtitle.text(
                                        productAvailabilityData.flyoutSubtitle != null
                                            ? productAvailabilityData.flyoutSubtitle
                                            : (productAvailabilityData.message
                                                || $availabilityFlyoutSubtitle.data('subtitle-lowstock')
                                                || '')
                                    );
                                } else if (stockState === 'limitedstock') {
                                    $availabilityFlyoutSubtitle.text(
                                        productAvailabilityData.flyoutSubtitle != null
                                            ? productAvailabilityData.flyoutSubtitle
                                            : ($availabilityFlyoutSubtitle.data('subtitle-limitedstock') || '')
                                    );
                                } else {
                                    $availabilityFlyoutSubtitle.text(productAvailabilityData.message || '');
                                }
                                $availabilityFlyoutSubtitle.toggleClass(
                                    'd-none',
                                    !$availabilityFlyoutSubtitle.text()
                                );
                            }
                            // Refresh the Order online link after the URL has been pushed for the
                            // new attribute selection (handled by frontendUtils.updateUrlParams
                            // elsewhere in this response), so the href continues to point at the
                            // user's current build.
                            syncAvailabilityOrderOnlineHref();
                            var $checkoutCTASelector = configuratorCtas.$availability();

                            if (!productAvailabilityData.isProductOrderable) {
                                $checkoutCTASelector.prop('disabled', true).addClass('disabled');
                                $checkoutCTASelector.attr('data-isProductOrderable', false);
                                $checkoutCTASelector.data('isProductOrderable', false);
                            } else {
                                $checkoutCTASelector.prop('disabled', false).removeClass('disabled');
                                $checkoutCTASelector.attr('data-isProductOrderable', true);
                                $checkoutCTASelector.data('isProductOrderable', true);
                            }

                            configuratorCtas.reapplyOrderNowDisabled();

                            $footerDealerAvailability.removeClass('opacity-50');
                            $navbarDealerAvailability.removeClass('opacity-50');
                        }

                        if (response.data.product.productType !== 'master') {
                            if (response.data.carouselNoTabsHtml) {
                                updateNoTabsImages(response.data.carouselNoTabsHtml);
                                updateTabsImages(response);
                            }
                        }

                        if (response.data.carKeySpecificationsModalHtml) {
                            updateKeySpecifications(response.data.carKeySpecificationsModalHtml);
                        }

                        var selectedVariantColor = response.container.find('#attribute-color .color-attribute .color-value.selected');
                        var selectedVariantColorValue = selectedVariantColor.data('attr-value');
                        var params = new URLSearchParams(window.location.search);
                        var modifyCar = params.get('modifyCar') || '';
                        var crossBorderDelivery = params.get('crossBorderDelivery') || '';
                        var purchasedVariant = sessionStorage.getItem('modifySelectedOrderVariant') !== null ? JSON.parse(sessionStorage.getItem('modifySelectedOrderVariant')) : '';
                        var currentUrl = new URL(window.location.href);
                        var carModel = currentUrl.pathname.split('/').pop().split('.')[0];
                        var selectedGrade = (response.data.requestDataValue && response.data.requestDataValue.grade) || '';
                        var colorChanged = purchasedVariant && selectedVariantColorValue != purchasedVariant.variantColor;
                        var gradeChanged = purchasedVariant && selectedGrade && selectedGrade !== purchasedVariant.variant;

                        if (modifyCar && purchasedVariant && (colorChanged || gradeChanged)) {
                            $('.product-recommendations-accessories-pack, .product-recommendations-accessories, .product-recommendations-accessories-membership, .product-recommendations-accessories-cross-sell').css({ 'pointer-events': 'unset', 'opacity': '1' });
                        }

                        if (modifyCar && colorChanged) {
                            $('.grade-attribute .radio-cards__card').removeClass('grade-protected-price');
                        } else if (carModel == purchasedVariant.carModel) {
                            $('.grade-attribute input[name="grade"]').each(function () {
                                if ($(this).attr('id') == purchasedVariant.variant && modifyCar) {
                                    $(this).closest('.radio-cards__card').addClass('grade-protected-price');
                                }
                            });
                        }

                        updateVariantURLParameters(response.data.requestDataValue, response.data.product.id);
                        updateModifyOrderColorLock(response.data.requestDataValue);
                        updateGradeAttrData(response.data.product, response.container);
                        triggerStockLabelEvent(response.data.product);

                        configuratorStageConfigure.updateCrossBorderContainer(crossBorderDelivery, response);

                        var productListUrl = urlHelper.prepareUrl($('input[name="productListCount"]').val(), {
                            include: ['acc', 'accpk', 'mem', 'm'],
                            exclude: response.data.removeList ? ['acc', 'accpk', 'mem'] : [],
                            params: { m: response.data.product.id }
                        });

                        $.ajax({
                            url: productListUrl,
                            type: 'get',
                            dataType: 'json',
                            success: function (data) {
                                if (data.selectedAccessoryInfo) {
                                    $('#selectedAccessoryInfo').html(data.selectedAccessoryInfo);
                                }

                                if (data.isEmpty) {
                                    window.history.replaceState({}, document.title, removeParamsFromUrl(window.location.href, ['acc', 'accpk', 'mem']));
                                }
                            }
                        });
                        var showroomStock = params.get('showroomStock') === 'true';
                        if (!showroomStock && response.data.crossBorderDelivery && response.data.crossBorderCharge) {
                            frontendUtils.updateUrlParams({
                                'crossBorderDelivery': response.data.crossBorderDelivery,
                                'crossBorderCharge': response.data.crossBorderCharge
                            });
                            $('.cross-border-details-container').addClass('d-none');
                        }
                        updatePromotionalTiles(response.data.promotionsHtml);
                        updateWarrantyExtras(response.data.warrantyExtrasHtml);
                        updateOffers(response.data.offersHtml);
                        updateGradeOfferPills(response.data.gradeOfferPillsHtml);
                        configuratorRecommendation.updateRecommendationParentProduct(response.data.product.id);
                        var campaigns = response.data.protectedCampaigns;
                        if (campaigns) {
                            updateCampaignParameters(campaigns);
                        } else if (campaigns === '') {
                            updateCampaignParameters('');
                        } else {
                            updateCampaignParameters(response.data.product.promotions);
                        }

                        modifyOrderURLParameters();
                        updateInternalVehicleNumFields(response.data.internalVehicleNumberFields ? response.data.internalVehicleNumberFields : '');
                        handleStackedModals();

                        if (response.data.product.productType !== 'master') {
                            $('.configurator-specs').addClass('show');
                            $('.configurator-specs__promotions').addClass('show');
                            $('#carouselExterior').addClass('show');
                            refreshRecommendationCarousels();
                            $('.configurator-variation-promotions').addClass('show');
                            $('.variation-base_slots').children().spinner().stop();
                            setTimeout(function () {
                                $('#variation-based-slot__recommendation').spinner().stop();
                                $('.variation-base_slots').removeClass('show');
                                $('.variation-base_slots').addClass('show');
                                $('#variation-based-slot__recommendation .variation-based-slot__recommendation-content').addClass('show');
                            }, 2000);

                            var showSummaryParam = new URLSearchParams(window.location.search).get('showSummary') === 'true';
                            var onSummaryStage = $('body').hasClass('configurator-stage-summary');

                            if (showSummaryParam || onSummaryStage) {
                                $('.add-to-cart-global').trigger('click');
                            }

                            if (showSummaryParam) {
                                $('#configuratorSummary-tab').trigger('click');
                                localStorage.setItem('syncTabRefresh', Date.now().toString());
                                configurator.updateStage('summary');
                            }
                        }
                        var $productContainer = $('.product-detail');
                        var carousel = $productContainer.find('.carousel');
                        $($(carousel).find('.carousel-item')).first().find('img').attr('fetchpriority', 'high');
                    } catch (error) {
                        $(`.variation-grade__price`).each(function () {
                            $(this).html(`<div class="skeleton skeleton-md px-5"></div>`);
                        });
                        $footerDealerAvailability.html(`<div class="skeleton skeleton-sm px-5"></div>`);
                        $configuratorSummaryDealerAvailability.html(`<div class="skeleton skeleton-sm px-5"></div>`);
                        $navbarDealerAvailability.html(`<div class="skeleton skeleton-sm px-5"></div>`);
                        $selectGradeMobileBtnPrice.html(`<div class="skeleton skeleton-sm px-5"></div>`);
                        console.error(error);
                    }

                    // --- Build CTA / Configurator gating (Rules 1..8) ---
                    try {
                        const viewerCtx = buildCTAEvaluator.getViewerContextFromURL();
                        const decision = buildCTAEvaluator.evaluateBuildCTAFront(response.data, viewerCtx);
                        applyConfiguratorDecision(decision);
                    } catch (ctaErr) {
                        console.warn('CTA rules evaluation failed:', ctaErr);
                    }
                });
            },
            removeParamsFromUrl: function (url, paramsToRemove) {
                const urlObj = new URL(url);
                const searchParams = urlObj.searchParams;
                paramsToRemove.forEach(param => {
                    searchParams.delete(param);
                });
                return urlObj.origin + urlObj.pathname + (searchParams.toString() ? '?' + searchParams.toString() : '') + urlObj.hash;
            },
            /**
             * Paint the modify-car price-protection lock on the purchased color chip
             * from the Variation response grade, not a delayed `?v=` read.
             *
             * @param {Object} [requestDataValue]
             */
            updateModifyOrderColorLock: function (requestDataValue) {
                var params = new URLSearchParams(window.location.search);
                var modifyCar = params.get('modifyCar') || '';
                var purchasedVariant = null;
                var currentGrade;
                var carModel;
                var lockColorId;

                if (!modifyCar) {
                    return;
                }

                try {
                    purchasedVariant = sessionStorage.getItem('modifySelectedOrderVariant') !== null
                        ? JSON.parse(sessionStorage.getItem('modifySelectedOrderVariant'))
                        : null;
                } catch (e) {
                    purchasedVariant = null;
                }

                if (!purchasedVariant) {
                    return;
                }

                carModel = new URL(window.location.href).pathname.split('/').pop().split('.')[0] || '';
                currentGrade = (requestDataValue && requestDataValue.grade) || params.get('v') || '';

                $('#attribute-color .color-attribute').removeClass('modify-order-ordered-value');

                if (carModel != purchasedVariant.carModel) {
                    return;
                }

                if (purchasedVariant.variant !== currentGrade) {
                    return;
                }

                lockColorId = purchasedVariant.variantColor || null;

                if (!lockColorId) {
                    return;
                }

                $('#attribute-color .color-attribute').each(function () {
                    if ($(this).data('value') == lockColorId) {
                        $(this).addClass('modify-order-ordered-value');
                    }
                });
            },
            updateGradeAttrData: function (product, $productContainer) {
                var params = new URLSearchParams(window.location.search);
                var modifyOrderFlow = params.get('orderId') || '';
                var userId = params.get('userId') || '';
                var sessionId = params.get('sessionId') || '';
                var modelDiscontinued = $('#modeldiscontinued').val() == 'true';

                var modelParamsString = $('#modelparams').val();
                var modelParams = new URLSearchParams(modelParamsString);
                var modelParamsColor = modelParams.get('sv');
                var modelParamsGrade = modelParams.get('v');

                var attrs = product.variationAttributes;
                var attrsWithSwatches = ['color'];
                var isOnlineFlow = !userId && !sessionId && !modifyOrderFlow;
                var defaultColorValue = $('#attribute-color').attr('data-default-color') || '';

                // Runs after every swatch is painted: the default colour when it is still offered, else the first selectable one.
                var selectFallbackColor = function (delay) {
                    setTimeout(() => {
                        var $defaultColorValue = $('#attribute-color .color-value').filter(function () {
                            return !!defaultColorValue && $(this).attr('data-attr-value') === defaultColorValue;
                        }).first();
                        var isDefaultColorOffered = $defaultColorValue.length > 0 &&
                            !$defaultColorValue.hasClass('d-none') &&
                            !$defaultColorValue.hasClass('is-discontinued') &&
                            $defaultColorValue.parent().is('[data-url]');

                        if (isDefaultColorOffered) {
                            $defaultColorValue[0].click();

                            return;
                        }

                        document.querySelector('.color-value.selectable:not(.is-discontinued)')?.click();
                    }, delay);
                };

                /** stock label logic starts */
                var displayColorOutOfStockLabel = false;
                var displayColorLowStockLabel = false;
                var hideColorOutOfStockLabel = false;
                var hideColorLowStockLabel = false;
                $('.color_stocklabel_outofstock2').addClass('d-none');
                $('.color_stocklabel_lowstock2').addClass('d-none');
                $('#configurator-footer-actions-summary').removeClass('show_grade_outofstock_label');
                $('#configurator-footer-actions-summary-m').removeClass('show_grade_outofstock_label');
                /** stock label logic ends */

                attrs.forEach(function (attr) {
                    var $attr = '[data-attr="' + attr.id + '"]';
                    if (attrsWithSwatches.indexOf(attr.id) > -1) {
                        attr.values.forEach(function (attrValue) {
                            var $attrValue = $productContainer.find($attr + ' [data-attr-value="' + attrValue.value + '"]');
                            var $swatchButton = $attrValue.parent();

                            // Disable if not selectable
                            $attrValue.removeClass('d-none is-discontinued');
                            $attrValue.parent().removeClass('d-none is-discontinued');

                            if (modelDiscontinued) {
                                $attrValue.addClass('d-none');
                                $swatchButton.removeAttr('data-url');
                                if (attrValue.value === modelParamsColor) {
                                    $attrValue.removeClass('d-none');
                                }
                                return;
                            }

                            if (attrValue.selectable) {
                                $attrValue.removeClass('d-none');
                                $swatchButton.attr('data-url', attrValue.url);
                            } else {
                                $attrValue.addClass('d-none');
                                $swatchButton.removeAttr('data-url');

                                if (modifyOrderFlow && (attrValue.selected || attrValue.value == modelParamsColor)) {
                                    $attrValue.removeClass('d-none');
                                } else if (attrValue.selected) {
                                    selectFallbackColor(100);
                                }
                            }

                            if (attrValue.discontinued || (isOnlineFlow && attrValue.isLowStock)) {
                                $attrValue.addClass('d-none is-discontinued');
                                $attrValue.parent().addClass('d-none is-discontinued');
                                $swatchButton.removeAttr('data-url');
                                var wasSelectable = attrValue.selectable;
                                attrValue.selectable = false;
                                if (modifyOrderFlow && (attrValue.selected || attrValue.value == modelParamsColor)) {
                                    $attrValue.removeClass('d-none is-discontinued');
                                    $attrValue.parent().removeClass('d-none is-discontinued');
                                    $swatchButton.removeAttr('data-url');
                                    attrValue.selectable = wasSelectable;
                                } else if (attrValue.selected) {
                                    selectFallbackColor(300);
                                }
                            }

                            /** stock label logic starts */
                            // Remove class that starts with stocklabel
                            $swatchButton.removeClass(function (_, className) {
                                return (className.match(/(^|\s)stocklabel-\S+/g) || []).join(' ');
                            });
                            $swatchButton.find('.color_stocklabel_outofstock').addClass('d-none');
                            $swatchButton.find('.color_stocklabel_lowstock').addClass('d-none');

                            if (attrValue.stockLabel == 'outofstock') {
                                $swatchButton.addClass('stocklabel-outofstock');
                                $swatchButton.find('.color_stocklabel_outofstock').removeClass('d-none');
                                if (attrValue.selected) {
                                    displayColorOutOfStockLabel = true;
                                }
                            } else if (attrValue.stockLabel == 'lowstock') {
                                $swatchButton.addClass('stocklabel-lowstock');
                                $swatchButton.find('.color_stocklabel_lowstock').removeClass('d-none');
                                if (attrValue.selected) {
                                    displayColorLowStockLabel = true;
                                }
                            }
                            /** stock label logic ends */
                        });
                    } else {
                        attr.values.forEach(function (attrValue) {
                            var $attrValue = $productContainer.find($attr + ' [data-attr-value="' + attrValue.value + '"]');
                            var $swatchButton = $attrValue.parent();
                            $attrValue.attr('value', attrValue.url).removeAttr('disabled');
                            var availableColorCount = parseInt($attrValue.data('available-color-options') || '0', 10);
                            if (attrValue.selectable || availableColorCount > 0) {
                                $attrValue.removeAttr('disabled');
                            } else {
                                $attrValue.attr('disabled', true);
                            }

                            $swatchButton.removeClass('d-none');
                            if (modelDiscontinued && attrValue.value !== modelParamsGrade) {
                                $swatchButton.addClass('d-none');
                            }
                            // Respect rules-driven filtering for non-swatch attributes too
                            var flags = buildCTAEvaluator.getFlags();
                            var viewerContext = buildCTAEvaluator.getViewerContextFromURL();

                            if (flags && flags.filterDiscontinued && attrValue.discontinued && availableColorCount === 0) {
                                $swatchButton.addClass('d-none is-discontinued');
                            }
                            if (flags && flags.filterDealerOnly && attrValue.dealerViewOnly === true && !viewerContext.isDealer) {
                                $swatchButton.addClass('d-none is-dealer-only');
                            }

                            /** stock label logic starts */
                            // Remove class that starts with stocklabel
                            $swatchButton.removeClass(function (_, className) {
                                return (className.match(/(^|\s)stocklabel-\S+/g) || []).join(' ');
                            });
                            $swatchButton.find('.grade_stocklabel_outofstock').addClass('d-none');
                            $swatchButton.find('.grade_stocklabel_lowstock').addClass('d-none');

                            if (attrValue.stockLabel == 'outofstock') {
                                $swatchButton.addClass('stocklabel-outofstock');
                                $swatchButton.find('.grade_stocklabel_outofstock').removeClass('d-none');
                                if (attrValue.selected) {
                                    hideColorOutOfStockLabel = true;
                                    $('#configurator-footer-actions-summary').addClass('show_grade_outofstock_label');
                                    $('#configurator-footer-actions-summary-m').addClass('show_grade_outofstock_label');
                                }
                            } else if (attrValue.stockLabel == 'lowstock') {
                                $swatchButton.addClass('stocklabel-lowstock');
                                $swatchButton.find('.grade_stocklabel_lowstock').removeClass('d-none');
                                if (attrValue.selected) {
                                    hideColorLowStockLabel = true;
                                }
                            }
                            /** stock label logic ends */
                        });
                    }
                });

                /** stock label logic starts */
                if (displayColorOutOfStockLabel && !hideColorOutOfStockLabel) {
                    $('.color_stocklabel_outofstock2').removeClass('d-none');
                }

                if (displayColorLowStockLabel && !hideColorLowStockLabel) {
                    $('.color_stocklabel_lowstock2').removeClass('d-none');
                }
                /** stock label logic ends */
            },
            triggerStockLabelEvent: function (product) {
                // If main product is marked as out of stock, then disallow next page actions
                $(configuratorCtas.BUILD).removeClass('stocklabel-outofstock');
                $('.configuratorSummary-tab-proxy').removeClass('stocklabel-outofstock');
                $('#summary-next').removeClass('stocklabel-outofstock');
                if (product.stockLabel == 'outofstock') {
                    $(configuratorCtas.BUILD).addClass('stocklabel-outofstock');
                    $('.configuratorSummary-tab-proxy').addClass('stocklabel-outofstock');
                    $('#summary-next').addClass('stocklabel-outofstock');
                    $('#configurator-footer-dealer-availability').html('');
                    var $navbarAvail = $('#configurator-navbar-dealer-availability');
                    var lowstockLabel = $navbarAvail.data('label-lowstock') || '';
                    $navbarAvail.text(lowstockLabel);
                    $('.region--addon-detail .summary-item.availability')
                        .removeClass('is-instock is-onwater is-onorder is-lowstock is-limitedstock')
                        .addClass('is-lowstock');

                    // Mirror the same out-of-stock pivot inside the availability flyout so the
                    // user sees the Honda Centre contact card (and the "Call Honda Centre" CTA)
                    // even if the flyout is already open when stock disappears.
                    var $flyout = $('.modal-view--availability');
                    if ($flyout.length) {
                        $flyout
                            .removeClass('is-instock is-onwater is-onorder is-lowstock is-limitedstock')
                            .addClass('is-lowstock');
                        var $flyoutLabel = $('#availability-flyout-state-label');
                        var $flyoutSubtitle = $('#availability-flyout-subtitle');
                        $flyoutLabel.text(lowstockLabel);
                        $flyoutSubtitle.text($flyoutSubtitle.data('subtitle-lowstock') || '');
                        $flyoutSubtitle.toggleClass('d-none', !$flyoutSubtitle.text());
                    }
                }
            },
            handleStackedModals: function () {
                var $modalone = $('#accessories-pack-details');
                var $modaltwo = $('#pack-component-content');

                $modaltwo.on('show.bs.modal', function () {
                    $modalone.css('z-index', 1040);
                });

                $modaltwo.on('hidden.bs.modal', function () {
                    $modalone.css('z-index', 1055);

                    if ($modalone.hasClass('show')) {
                        $('body').addClass('modal-open');
                    }
                });

                $modalone.on('hidden.bs.modal', function () {
                    if ($('.modal.show').length === 0) {
                        $('body').removeClass('modal-open');
                    }
                });
            },
            updateNoTabsImages: function (carousel) {
                $('.carousel-no-tabs__slot').each(function () {
                    $(this).html(carousel);
                    $('body').trigger('configurator:imagesCarousel:no-tabs:init');
                });
            },
            updateTabsImages: function (response) {
                var carousel = response.container.find('#carouselInterior');
                var imgs = response.data.product.images.interior;
                $(carousel).carousel('dispose');
                var carouselId = $(carousel).attr('id');
                $(carousel).empty().append('<ol class="carousel-indicators"></ol><div class="carousel-inner" role="listbox"></div><a class="carousel-control-prev" href="#' + carouselId + '" role="button" data-slide="prev"><span class="fa icon-prev" aria-hidden="true"></span><span class="sr-only">' + $(carousel).data('prev') + '</span></a><a class="carousel-control-next" href="#' + carouselId + '" role="button" data-slide="next"><span class="fa icon-next" aria-hidden="true"></span><span class="sr-only">' + $(carousel).data('next') + '</span></a>');
                for (var i = 0; i < imgs.length; i++) {
                    $('<div class="carousel-item"><img src="' + imgs[i].url + '" class="d-block img-fluid" alt="' + imgs[i].alt + ' image number ' + parseInt(imgs[i].index, 10) + '" title="' + imgs[i].title + '" itemprop="image" /></div>').appendTo($(carousel).find('.carousel-inner'));
                    $('<li data-target="#' + carouselId + '" data-slide-to="' + i + '" class=""></li>').appendTo($(carousel).find('.carousel-indicators'));
                }
                $($(carousel).find('.carousel-item')).first().addClass('active');
                $($(carousel).find('.carousel-indicators > li')).first().addClass('active');
                if (imgs.length === 1) {
                    $($(carousel).find('.carousel-indicators, a[class^="carousel-control-"]')).detach();
                }
                $(carousel).carousel();
                $($(carousel).find('.carousel-indicators')).attr('aria-hidden', true);
            },
            updateKeySpecifications: function (carKeySpecificationsModalHtml) {
                var slot = document.getElementById('keyspec-view-all-slot');

                if (!slot || !carKeySpecificationsModalHtml) {
                    return;
                }

                // amb-flyout moves #keyspecviewall onto <body>. Replacing only the slot
                // leaves that copy in place, and it stays the first match for the id.
                document.querySelectorAll('#keyspecviewall').forEach(function (existing) {
                    existing.remove();
                });

                slot.innerHTML = carKeySpecificationsModalHtml;

            },
            setupKeySpecModalBackdropClick: function () {
                // Enable closing modal when clicking outside (same behavior as close button)
                let $modal = $('#keyspecviewall');
                if ($modal.length) {
                    $modal.off('click.backdropClose').on('click.backdropClose', function(e) {
                        if (e.target === e.currentTarget) {
                            $modal.modal('hide');
                        }
                    });
                }
            },
            initDefaultVariation: function () {
                var $defaultColor = $('.color-attribute').has('.color-value.selected').first();

                $(document).on('click', '.form-check-input.options-select.invisible.flex-warp', function () {
                    $('.offcanvas .btn-close').trigger('click');
                });

                $('#current-product').addClass('show');
                configuratorGradesAccordion.populateColorVariationPrice($defaultColor.data('value'));
            },

            /**
             * Load-time grade click, the same on every width. Clears a pre-checked grade so the
             * Variation request still fires, and copies the link's saved-build code, the
             * first-HTML colour, cross-border and modify-order params onto the grade URL.
             */
            runLoadGradeClick: function () {
                var $currentProduct = $('#current-product');
                var urlParams = new URLSearchParams(window.location.search);
                var crossBorderDelivery = urlParams.get('crossBorderDelivery') || '';
                var orderId = urlParams.get('orderId') || '';
                var action = urlParams.get('action') || '';
                var modifyAccessories = urlParams.get('modifyAccessories') || '';
                var modifyCar = urlParams.get('modifyCar') || '';
                var code = urlParams.get('code');
                var $defaultColor = $('.color-attribute').has('.color-value.selected').first();
                var selectedVariant = $currentProduct.data('producttype') === 'master'
                    ? urlParams.get('v')
                    : $currentProduct.data('grad-desc');
                var $defaultVariant;

                if (selectedVariant) {
                    $defaultVariant = $('.grade-attribute input').filter(function () {
                        return this.id === selectedVariant;
                    });
                }

                if (!selectedVariant || $defaultVariant.length == 0) {
                    $defaultVariant = $('.grade-attribute input:enabled').first();
                }

                if ($(`[id="${selectedVariant}"]`).is(':checked')) {
                    $(`[id="${selectedVariant}"]`).prop('checked', false);
                }

                var gradeValue = $defaultVariant.attr('id');
                var url = new URL($defaultVariant.val());
                var params = url.searchParams;

                if (code) {
                    params.set('loadBuild', code);
                    url.search = params.toString();
                    $defaultVariant.val(url.toString());
                }

                if (!params.get('dwvar_' + params.get('pid') + '_grade')) {
                    params.set('dwvar_' + params.get('pid') + '_grade', gradeValue);
                    params.set('dwvar_' + params.get('pid') + '_grade', gradeValue, 'loadBuild', !!(code && code.length));
                    url.search = params.toString();
                    $defaultVariant.val(url.toString());
                }

                if (params.get('dwvar_' + params.get('pid') + '_color')) {
                    params.set('dwvar_' + params.get('pid') + '_color', $defaultColor.data('value'));
                    params.set('dwvar_' + params.get('pid') + '_color', $defaultColor.data('value'));
                    url.search = params.toString();
                    $defaultVariant.val(url.toString());
                }

                configuratorStageConfigure.updateCrossBorderContainer(crossBorderDelivery, null, { params: params, url: url, $defaultVariant: $defaultVariant });

                if (orderId) {
                    params.set('orderId', orderId);
                    url.search = params.toString();
                    $defaultVariant.val(url.toString());
                }

                if (action) {
                    params.set('action', action);
                    url.search = params.toString();
                    $defaultVariant.val(url.toString());
                }

                if (modifyAccessories) {
                    params.set('modifyAccessories', modifyAccessories);
                    url.search = params.toString();
                    $defaultVariant.val(url.toString());
                }

                if (modifyCar) {
                    params.set('modifyCar', modifyCar);
                    url.search = params.toString();
                    $defaultVariant.val(url.toString());
                }

                $defaultVariant.trigger('click');
            },
            initStageEvents: function () {
                let $configuratorFooterAccordion = $('#configurator-footer-accordion');
                var priceProtectedIcon = '<svg width="18" height="18" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                    '<g id="Size=L">' +
                    '<path id="Union" fill-rule="evenodd" clip-rule="evenodd" ' +
                    'd="M24 6C21.8783 6 19.8434 6.84285 18.3431 8.34315C16.8429 9.84344 16 11.8783 16 14V20H32V14C32 11.8783 31.1571 9.84344 29.6569 8.34315C28.1566 6.84285 26.1217 6 24 6ZM36 20V14C36 10.8174 34.7357 7.76516 32.4853 5.51472C30.2348 3.26428 27.1826 2 24 2C20.8174 2 17.7652 3.26428 15.5147 5.51472C13.2643 7.76516 12 10.8174 12 14V20H10C6.68629 20 4 22.6863 4 26V40C4 43.3137 6.68629 46 10 46H38C41.3137 46 44 43.3137 44 40V26C44 22.6863 41.3137 20 38 20H36ZM34 24H14H10C8.89543 24 8 24.8954 8 26V40C8 41.1046 8.89543 42 10 42H38C39.1046 42 40 41.1046 40 40V26C40 24.8954 39.1046 24 38 24H34Z" ' +
                    'fill="#FFFFFF"></path>' +
                    '</g>' +
                    '</svg>';

                if (window.innerWidth > commonOptions.breakpoints.sm) {
                    $configuratorFooterAccordion.addClass('active');
                    $configuratorFooterAccordion.addClass('show');
                }

                // Swatch `.preview` sits outside `button.detail`; forward clicks so the
                // existing SFRA colorAttribute handler (fresh data-url) still runs.
                $(document).on('click', '#attribute-color .color-attribute .preview', function () {
                    var $row = $(this).closest('.color-attribute');
                    var $detail = $row.children('button.detail');

                    if (!$detail.length || $detail.prop('disabled') || $detail.is('[disabled]')) {
                        return;
                    }

                    if ($row.find('.color-value.selected').length) {
                        return;
                    }

                    $detail.trigger('click');
                });

                // Setup backdrop click handler for key specifications modal when it's shown
                $(document).on('shown.bs.modal', '#keyspecviewall', function () {
                    configurator.stage.configure.setupKeySpecModalBackdropClick();
                });

                $(document).on('click', '.recommendation-tiles input:radio', function () {
                    var check = $(this).attr('checked')
                    if (check) {
                        $(this).removeAttr('checked').prop('checked', false);
                        $(this).val('on');
                    } else {
                        $(this).attr('checked', true).prop('checked', true);
                        $(this).val('');
                    }
                });

                function syncAccessoryActionState(forId, checked) {
                    if (!forId) {
                        return;
                    }

                    $('.action-button-js').filter(function () {
                        return this.getAttribute('for') === forId;
                    }).each(function () {
                        $(this).find('.recommendation-tile__action-add').toggleClass('d-none', checked);
                        $(this).find('.recommendation-tile__action-remove').toggleClass('d-block', checked);
                    });
                }

                $('body').on('click', '.recommendation-tile__action-input', function () {
                    syncAccessoryActionState(this.id, this.checked);
                });

                $('body').on('click', '.action-button-js', function (event) {
                    var forId = this.getAttribute('for');
                    var inputs = forId ? document.querySelectorAll('[id="' + CSS.escape(forId) + '"]') : [];

                    if (!inputs.length) {
                        return;
                    }

                    event.preventDefault();
                    $('#accessory-details-flyout').data('actionFromFlyout', true);
                    inputs[0].click();

                    var checked = inputs[0].checked;

                    for (var i = 1; i < inputs.length; i++) {
                        inputs[i].checked = checked;
                    }

                    syncAccessoryActionState(forId, checked);
                });

                function initAccessoryDetailSliders($root) {
                    $root.find('.custom-slider').each(function () {
                        var $this = $(this);
                        var slideConfig = {
                            arrows: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true,
                            prevArrow: `<button type="button" class="slick-prev"><div class="icon icon-angle-left --icon-light "><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Size=L, Fill=Off, Direction=West"><path id="Union" d="M28.05 36.6785L15.3215 23.95L28.05 11.2215L30.8785 14.05L20.9785 23.95L30.8785 33.85L28.05 36.6785Z" fill="#0A0A0A"></path></g></svg></div></button>`,
                            nextArrow: `<button type="button" class="slick-next"><div class="icon icon-angle-left --icon-light "><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Size=L, Fill=Off, Direction=East"><path id="Union" d="M25.8215 23.95L15.9215 14.05L18.75 11.2215L31.4785 23.95L18.75 36.6785L15.9215 33.85L25.8215 23.95Z" fill="#0A0A0A"></path></g></svg></div></button>`
                        };

                        if ($this.hasClass('slick-initialized')) {
                            $this.slick('unslick');
                        }

                        $this.slick(slideConfig);
                        $this.find('img').off('load.accessorySlider').on('load.accessorySlider', function () {
                            if ($this.hasClass('slick-initialized')) {
                                $this.slick('setPosition');
                            }
                        });
                    });
                }

                $('#recommendation-tile__learn-more-pack-content, #recommendation-tile__learn-more-content-p-component, #recommendation-tile__learn-more-content, #accessory-details-flyout-content, #accessory-pack-details-flyout-content').on('htmx:afterSettle', function () {
                    initAccessoryDetailSliders($(this));
                });

                $('#accessory-details-flyout').on('shown.bs.modal', function () {
                    $(this).find('.custom-slider.slick-initialized').each(function () {
                        $(this).slick('setPosition');
                    });
                });

                $('#configurator-google-autocomplete').on('keyup', function () {
                    var regex = /(?:\D*\d){5,}/;
                    var $configuratorGoogleInput = $(this);
                    var $configuratorGoogleInputInvalid = $('.configurator-google-autocomplete-invalid');
                    var $userLocationInputInvalid = $('.configurator-location--invalid-error-msg');
                    var $locationApiError = $('#configurator-location-error-msg');
                    var $locationDealerContainer = $('#configurator-location-dealers');

                    $locationApiError.removeClass('d-flex');

                    if (!$configuratorGoogleInput.val()) {
                        $configuratorGoogleInputInvalid.html($userLocationInputInvalid.data('empty'));
                        $userLocationInputInvalid.addClass('d-flex');
                        $configuratorGoogleInput.trigger('focus');
                        $('.js-delete-location').css('display', 'inline-flex');
                        $locationDealerContainer.html('');
                        return false;
                    }

                    if (($configuratorGoogleInput.val().length > 1) && $('.pac-container .pac-item').length === 0) {
                        $configuratorGoogleInputInvalid.html($userLocationInputInvalid.data('invalid'));
                        $userLocationInputInvalid.addClass('d-flex');
                        $configuratorGoogleInput.trigger('focus');
                        $('.js-delete-location').css('display', 'inline-flex');
                        return false;
                    }

                    if (regex.test($configuratorGoogleInput.val())) {
                        $configuratorGoogleInputInvalid.html($userLocationInputInvalid.data('invalid'));
                        $userLocationInputInvalid.addClass('d-flex');
                        $configuratorGoogleInput.trigger('focus');
                        $locationDealerContainer.html('');
                       $('.js-delete-location').css('display', 'inline-flex');
                        return false;
                    }
                    $userLocationInputInvalid.removeClass('d-flex');
                    $locationApiError.removeClass('d-flex');
                    $('.js-delete-location').css('display', 'inline-flex');
                });

                var isShowroomStock = new URLSearchParams(window.location.search).get('showroomStock') === 'true';
                if (!isShowroomStock) {
                    $('#load-cross-border-order, #summary-get-cross-border-cta').on('click', (e) => {
                        e.preventDefault();
                        frontendUtils.updateUrlParams({
                            'crossBorderDelivery': true
                        });
                        location.reload();
                    });

                    $('#remove-cross-border-from-order').on('click', (e) => {
                        e.preventDefault();
                        frontendUtils.deleteUrlParams('crossBorderDelivery,crossBorderCharge');
                        $('.cross-border-alert-message').addClass('d-none');
                        location.reload();
                    });
                }

                $('body').on('click', '#summary-next', function (e) {
                    var $nextNode = $('#configuratorTab').find('.nav-item >.active').parent('.nav-item').next('.nav-item');

                    // Configure → Summary
                    if ($nextNode.children('button').attr('id') === 'configuratorSummary-tab') {
                        $('#configurator-footer-actions-summary').trigger('click');

                        return;
                    }

                    // Summary → Order
                    var $navItem = $nextNode.find('button.nav-link');

                    $navItem = $navItem.length ? $navItem : $nextNode.find('>a').first();

                    // Programmatic .click() bypasses d-none / CSS pointer-events; block Order when unavailable.
                    if (!$navItem.length || ($navItem.is('#configuratorOrder-tab') && ($navItem.hasClass('d-none') || $navItem.hasClass('disabled')))) {
                        e.preventDefault();

                        return;
                    }

                    $navItem.trigger('click');
                });

                $('body').on('click', '#customse-prev', function (e) {
                    var $navItem = $('#configuratorTab').find('.nav-item >.active').parent('.nav-item').prev('.nav-item').find('button.nav-link');
                    $navItem.length ? $navItem.trigger('click') : '';
                });


                $('body').on('change', '.js-membership-multicard-select', function () {
                    var $multicardSelect = $(this);
                    var $multiSelectRecommendationTile = $multicardSelect.closest('.recommendation-tile');
                    var $selectedOption = $multicardSelect.find('option:selected');
                    $.spinner().stop();
                    $multiSelectRecommendationTile.spinner().start();
                    var $img = $multiSelectRecommendationTile.find('.js-card-img');
                    var $price = $multiSelectRecommendationTile.find('.js-card-price');
                    var $title = $multiSelectRecommendationTile.find('.js-card-title');
                    var $desc = $multiSelectRecommendationTile.find('.js-card-desc');
                    var $learnMore = $multiSelectRecommendationTile.find('.recommendation-tile__learn-more');
                    var $actionInput = $multiSelectRecommendationTile.find('.recommendation-tile__action-input');
                    var appendPriceProtectedIcon = $selectedOption.data('ispriceprotected') ? priceProtectedIcon : '';

                    $img.attr('src', $selectedOption.data('imagesrc'));
                    $price.html(appendPriceProtectedIcon + '$' + $selectedOption.data('price'));
                    $title.text($selectedOption.text());
                    $desc.html($selectedOption.data('description'));

                    $learnMore.attr('hx-get', $selectedOption.data('learnmoreurl'));

                    if ($actionInput.length && $actionInput.is(':checked')) {
                        $actionInput.trigger('click');
                        $actionInput.attr('hx-get', $selectedOption.data('actionurl'));
                        if (window.htmx && window.htmx.process) {
                            window.htmx.process($actionInput[0]);
                            setTimeout(() => {
                                $actionInput.trigger('click');
                            }, 1000);
                        }
                    }

                    if (window.htmx && window.htmx.process) {
                        $actionInput.attr('id', $selectedOption.data('forid'));
                        $actionInput.attr('hx-get', $selectedOption.data('actionurl'));
                        $actionInput.parent('.recommendation-tile__action').attr('for', $selectedOption.data('forid'));
                        window.htmx.process($actionInput[0]);
                        window.htmx.process($learnMore[0]);
                        setTimeout(() => {
                            $multiSelectRecommendationTile.spinner().stop();
                        }, 2000);
                    }

                });

                setTimeout(() => {
                    frontendUtils.syncDivsOnChange('membership-summary', 'membership-summary-m');
                }, 3000);

                $('body').on('click', '.btn-back', function (element) {
                    var $toast = $(this).closest('.modal').find('.configuration-code-copy-toast');
                    $toast.toast('hide');
                });

                $('.configurator-modal').on('hidden.bs.modal', function () {
                    var $toast = $(this).find('.configuration-code-copy-toast');
                    $toast.toast('hide');
                });

            },
            initImageCarousels: function () {

                $('body').on('configurator:imagesCarousel:interior:init', function () {
                    $('.carousel-interior').carousel({
                        ride: false,
                        interval: false
                    });
                    $('.carousel-interior .carousel-control-prev').on('click', function () {
                        $('.carousel-interior').carousel('prev');
                    });
                    $('.carousel-interior .carousel-control-next').on('click', function () {
                        $('.carousel-interior').carousel('next');
                    });
                });

                $('body').on('configurator:imagesCarousel:no-tabs:init', function () {
                    $('.carousel-no-tabs').each(function () {
                        let $this = $(this);
                        $this.carousel({
                            ride: false,
                            interval: false
                        });
                        $this.find('.carousel-control-prev').first().on('click', function () {
                            $this.carousel('prev');
                        });
                        $this.find('.carousel-control-next').first().on('click', function () {
                            $this.carousel('next');
                        });
                    });
                });

                $('body').trigger('configurator:imagesCarousel:interior:init');
                $('body').trigger('configurator:imagesCarousel:no-tabs:init');

            },
            offScreenSliderFix: function () {
                var selector = [
                    '#product-recommendations-accessories-pack',
                    '#product-summary-recommendations-accessories-cross-sell',
                    '#product-recommendations-up-sell-pack',
                    '#product-recommendations-membership-slot',
                    '#product-recommendations-up-sell-pack-config'

                ];
                $(selector.map(item => item + ' .recommendation-tiles').join()).each(function () {
                    var $this = $(this);
                    $this.addClass('fade');
                    $this.find('.slick-list.draggable').addClass('fade');
                    $this.find('.slick-list.draggable').removeClass('show');
                })
                setTimeout(() => {
                    $(selector.map(item => item + ' .recommendation-tiles').join()).each(function () {
                        var $this = $(this);
                        $this.slick('setPosition');
                        $this.addClass('show');
                        $this.find('.slick-list.draggable').addClass('show');
                    })
                }, 1000);
            },
            refreshRecommendationCarousels: function () {
                var selector = [
                    '#product-recommendations-accessories-pack',
                    '#product-summary-recommendations-accessories-cross-sell',
                    '#product-recommendations-up-sell-pack',
                    '#product-recommendations-up-sell-pack-config',
                    '#product-recommendations-membership-slot'
                ];
                $(selector.join()).on('htmx:afterSettle', function () {
                    $(selector.map(item => item + ' .recommendation-tiles').join()).each(function () {
                        var $this = $(this);
                        var sliderConfig = {
                            "slidesToShow": 3,
                            "slidesToScroll": 1,
                            "dots": true,
                            "infinite": false,
                            "prevArrow": `<button type="button" class="slick-prev"><div class="icon icon-angle-left"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Size=L, Fill=Off, Direction=West"><path id="Union" d="M28.05 36.6785L15.3215 23.95L28.05 11.2215L30.8785 14.05L20.9785 23.95L30.8785 33.85L28.05 36.6785Z" fill="#0A0A0A"></path></g></svg></div></button>`,
                            "nextArrow": `<button type="button" class="slick-next"><div class="icon icon-angle-right"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Size=L, Fill=Off, Direction=East"><path id="Union" d="M25.8215 23.95L15.9215 14.05L18.75 11.2215L31.4785 23.95L18.75 36.6785L15.9215 33.85L25.8215 23.95Z" fill="#0A0A0A"></path></g></svg></div></button>`,
                            "responsive": [{
                                "breakpoint": 1024,
                                "settings": {
                                    "arrows": false,
                                    "slidesToShow": 2.1,
                                    "slidesToScroll": 1,
                                    "variableWidth": false,
                                }
                            }, {
                                "breakpoint": 600,
                                "settings": {
                                    "arrows": false,
                                    "slidesToShow": 1.2,
                                    "slidesToScroll": 1,
                                    "variableWidth": false,
                                }
                            }]
                        }

                        switch ($this.parent().attr('id')) {
                            case 'product-recommendations-up-sell':
                                sliderConfig.dots = false;
                                break;
                            case 'product-recommendations-up-sell-config':
                                sliderConfig.slidesToShow = 1;
                                sliderConfig.dots = false;
                                break;
                            default:
                                break;
                        }

                        try {
                            $this.slick('unslick');
                            $this.slick(sliderConfig);
                        } catch {
                            $this.slick(sliderConfig);
                        } finally {
                            window.dispatchEvent(new Event('resize'));
                            $this.slick('setPosition');
                        }

                        setTimeout(function () {
                            window.cu = $this;
                            $this.children().spinner().stop();
                            $this.parents('.fade').addClass('show');
                            $this.parents('.recommendation-lazy').addClass('show');
                        }, 2000);
                    });

                });
            }, updatePromotionalTiles: function (htmlElement) {
                $('.configurator-variation-promotions').html(htmlElement);
            },
            updateWarrantyExtras: function (htmlElement) {
                if (!htmlElement) {
                    return;
                }

                $('.configurator-warranty-extras').html(htmlElement);
            },
            updateOffers: function (htmlElement) {
                if (!htmlElement) {
                    return;
                }

                $('body > [id^="modal-offers-tile-"]').remove();
                $('.configurator-offers').html(htmlElement);
            },
            updateGradeOfferPills: function (htmlElement) {
                if (htmlElement == null) {
                    return;
                }

                var $payload = $('<div></div>').html(htmlElement);
                var seen = {};

                $('body > [id^="modal-grade-offer-"]').remove();

                $payload.find('[data-grade-offer-slot]').each(function () {
                    var $incoming = $(this);
                    var gradeId = $incoming.attr('data-grade-id');
                    var slot = $incoming.attr('data-grade-offer-slot');
                    var $existing = $('.grade-attribute [data-grade-offer-slot="' + slot + '"]').filter(function () {
                        return $(this).attr('data-grade-id') === gradeId;
                    });

                    seen[gradeId + ':' + slot] = true;

                    if ($existing.length) {
                        $existing.replaceWith($incoming);
                    }
                });

                $('.grade-attribute [data-grade-offer-slot]').each(function () {
                    var $slot = $(this);
                    var key = $slot.attr('data-grade-id') + ':' + $slot.attr('data-grade-offer-slot');

                    if (!seen[key]) {
                        $slot.empty();
                    }
                });
            }
        },
        summary: {
            initSummaryActions: function () {
                $('#summary-action-modify-configuration').on('click', function () {
                    document.querySelector('.configurator-navigation .btn-back')?.click();
                });

                $('#configuratorSummary-tab-proxy').on('click', function () {
                    $('#configurator-footer-actions-summary').trigger('click');
                });

                $(document).on('click', '#drive-away-price-off-canvas-refresh-btn, #drive-away-price-refresh-btn', function () {
                    $('body').spinner().start();
                    window.location.reload();
                });
            },
            initStageEvents: function () {
                var updateSummaryData = this.updateSummaryData;

                $('body').on('product:afterAddToCart', function () {
                    updateSummaryData();
                });

                $('body').on('configurator:stageUpdate:configure', function () {
                    var $footerActionsCheckout = $('#configurator-footer-actions-checkout');
                    var $footerActionsSummary = $('#configurator-footer-actions-summary, #configurator-footer-actions-summary-m');
                    var $configuratorLocationConfirm = $('#configurator-location-confirm');

                    $footerActionsCheckout.addClass('d-none');
                    $footerActionsSummary.removeClass('d-none');
                    $configuratorLocationConfirm.removeClass('configurator-stage-summary');
                });

                $('body').on('configurator:stageUpdate:summary', function () {
                    var $configuratorLocationConfirm = $('#configurator-location-confirm');
                    $configuratorLocationConfirm.addClass('configurator-stage-summary');
                });

                $(document).on('click', '.refund-message-card .tooltip-activator', function () {
                    $('.configurator-summary__inclusions__field-set').toggleClass('d-none');
                });

                // Online-ordering refund copy is synced from Product-Variation via configurator.syncOnlineOrderingCTAs.

                document.body.addEventListener('htmx:afterSettle', function (event) {
                    window.lazyLoadInstance.update();
                });

            },
            updateSummaryData: function () {
                var urlParams = new URLSearchParams(window.location.search);
                var crossBorderDelivery = urlParams.get('crossBorderDelivery') || '';
                let $weeklyPaymentDetails = $('.weekly-payment-details');

                $.spinner().start();
                $.ajax({
                    url: $('#configurator-summary').data('action'),
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        var $summaryHeroDriveAway = $('.summary-hero-drive-away');
                        var $summaryOrderNowCtas = configuratorCtas.$orderNow();
                        var $summaryHeroHeroTitle = $('#summary-hero-title');
                        var $totalsFieldValueBasePrice = $('#totals-field-value-base-price');
                        var $totalsFieldValueDeposit = $('#totals-field-value-deposit');
                        var $summaryFieldDealerName = $('#configurator-summary-dealer-name');
                        var $totalsFieldValueBuildYear = $('#totals-field-value-variation-year');
                        var $totalsFieldValueDriveAway = $('#totals-field-value-drive-away');
                        var $totalsFieldValueExteriorName = $('#totals-field-value-exterior-name');
                        var $totalsFieldValueInteriorName = $('#totals-field-value-interior-name');
                        var $totalsFieldValueEandDEngineDrive = $('#totals-field-value-EandD-engine-drive');
                        var $totalsFieldValueEandDCapacity = $('#totals-field-value-EandD-capacity');
                        var $totalsFieldValueEandDWheels = $('#totals-field-value-EandD-wheels');
                        var $totalsFieldValueVariationName = $('#totals-field-value-variation-name');
                        var $totalsExteriorSwatch = $('#totals-exterior-swatch');
                        var $modifyOrderPrice = $('#totals-field-value-modify-order-price');
                        var $refundMsgDeposit = $('.summary-refund-msg-deposit');
                        var $headerDriveAwayPrice = $('.configurator-header-drive-away-price');
                        var initialDriveAwayPrice = $('.configurator-header-drive-away-price').html();
                        var $configuratorFooterDriveAwayPriceMobile = $('#configurator-footer-drive-away-price-m');
                        var $productBuildYearFull = $('.internal-Vehicle-number').find('input[name="productionDate"]').attr('value');
                        if ($productBuildYearFull) {
                            var $BuildYearDateObject = new Date($productBuildYearFull);
                            var $buildYear = $BuildYearDateObject.getFullYear();
                            $totalsFieldValueBuildYear.html($buildYear + ' build year');
                        }

                        var variationName = data.items[0].productName;
                        var gradeName = data.items[0].customProps.GradeDesc;
                        var driveAwayPrice = data.totals.finalDriveAwayPrice;

                        if (!driveAwayPrice || driveAwayPrice == '-') {
                            $headerDriveAwayPrice.addClass('d-none');
                            $configuratorFooterDriveAwayPriceMobile.addClass('d-none');
                            if (frontendUtils.getCookie('dapModalShown')) {
                                $('.gst-copy').addClass('d-none');
                                $('.header-dap').addClass('d-none');
                                $('#configurator-dap-not-available').removeClass('d-none').addClass('d-flex');
                                $('#configurator-dap-not-available-header').removeClass('d-none');
                            } else {
                                frontendUtils.setCookie(
                                    'dapModalShown',
                                    'true'
                                );
                                if (window.innerWidth < commonOptions.breakpoints.sm) {
                                    let driveAwayPriceErrorOffCanvas = new offcanvas('#offcanvasDriveAwayPriceErrorBottom', { backdrop: 'static', keyboard: false });
                                    driveAwayPriceErrorOffCanvas.show();
                                } else {
                                    $('#drive-away-price-error-modal').modal('show');
                                }
                                $('<div class="skeleton skeleton-md px-5 mb-2"></div>').insertAfter($headerDriveAwayPrice);
                                $('<div class="skeleton skeleton-md px-5 mb-2"></div>').insertAfter($configuratorFooterDriveAwayPriceMobile);
                            }
                            driveAwayPrice = "Price couldn't be retrieved";
                            $summaryHeroDriveAway.addClass('text-primary').addClass('d-none');
                            $summaryOrderNowCtas.addClass('disabled');
                            $configuratorFooterDriveAwayPriceMobile.addClass('text-primary');
                            $headerDriveAwayPrice.addClass('text-primary');
                        } else {
                            $('#configurator-dap-not-available').removeClass('d-flex').addClass('d-none');
                            $('#configurator-dap-not-available-header').addClass('d-none');
                            $('.gst-copy').removeClass('d-none');
                            $headerDriveAwayPrice.removeClass('d-none');
                            $('.header-dap').removeClass('d-none');
                            $headerDriveAwayPrice.removeClass('text-primary');
                            $summaryHeroDriveAway.removeClass('color-primary').removeClass('d-none');
                            if (configuratorCtas.isProductOrderable()) {
                                $summaryOrderNowCtas.removeClass('disabled');
                            }

                            configuratorCtas.reapplyOrderNowDisabled();
                            $configuratorFooterDriveAwayPriceMobile.removeClass('text-primary');
                        }

                        // stock label
                        $('.summary_stocklabel_lowstock').addClass('d-none');
                        $('.summary_stocklabel_message').addClass('d-none');
                        if (data.stockLabel == 'lowstock') {
                            $('.summary_stocklabel_lowstock').removeClass('d-none');
                            $('.summary_stocklabel_message').removeClass('d-none');
                        }
                        // end stock label

                        var deposit = data.totals.grandTotal;
                        var deposit = frontendUtils.formatCurrency(deposit);
                        var vehicleProduct = data.items.find(item => item.customProps && item.customProps.IsVehicle === true);
                        var dataCustomProps = vehicleProduct.customProps;
                        var vehiclePrice = vehicleProduct.discountedPrice ? vehicleProduct.discountedPrice : vehicleProduct.sellablePrice;
                        var formattedVehiclePrice = frontendUtils.formatCurrency(vehiclePrice);
                        var exteriorName = dataCustomProps.ColorDesc;
                        var interiorName = dataCustomProps.IntColorDesc;
                        var engineDrive = `${dataCustomProps.EngineHeader} + ${dataCustomProps.DriveWheels}`;
                        var seatsCapacity = `Capacity ${dataCustomProps.Seats} Seat`;
                        var driveWheels = dataCustomProps.WheelSize;
                        $totalsFieldValueVariationName.html(`${variationName} ${gradeName}`);
                        if (variationName.toLowerCase().includes(gradeName.toLowerCase())) {
                            $summaryHeroHeroTitle.html(variationName);
                        } else {
                            $summaryHeroHeroTitle.html(`${variationName} ${gradeName}`);
                        }
                        if (frontendUtils.getCookie('userloc')) {
                            var userLocation = JSON.parse(frontendUtils.getCookie('userloc') || 'null');
                            var dealerName = userLocation.dealer.dealerName;
                            $summaryFieldDealerName.html(dealerName);
                        }
                        $totalsFieldValueExteriorName.html(exteriorName);
                        $totalsFieldValueInteriorName.html(interiorName);
                        $totalsFieldValueDriveAway.html(driveAwayPrice);
                        $summaryHeroDriveAway.html(driveAwayPrice + '*');
                        $headerDriveAwayPrice.html(driveAwayPrice + '*');
                        $configuratorFooterDriveAwayPriceMobile.html(driveAwayPrice + '*');
                        $totalsFieldValueBasePrice.html(formattedVehiclePrice);
                        $totalsFieldValueDeposit.html(deposit);
                        $refundMsgDeposit.html(deposit);
                        $totalsFieldValueEandDEngineDrive.html(engineDrive);
                        $totalsFieldValueEandDCapacity.html(seatsCapacity);
                        $totalsFieldValueEandDWheels.html(driveWheels);
                        if ($modifyOrderPrice.html().trim() !== '') {
                            $modifyOrderPrice.removeClass('d-none');
                            $totalsFieldValueBasePrice.addClass('d-none');
                        }
                        $totalsExteriorSwatch.attr('style',
                            'height: 20px; width: 20px; border-radius: 15px;' +
                            ' background: ' + data.items[0].baseColorHex + ';' +
                            ' background-image: ' + data.items[0].swatchGradient + ';');

                        var $configuratorSummaryAccessories = $('#product-summary-recommendations-accessories-cross-sell');
                        $configuratorSummaryAccessories.removeAttr('data-hx-revealed');
                        var $configuratorSummaryAccessories = $('#configurator-summary-accessories');
                        $configuratorSummaryAccessories.removeAttr('data-hx-revealed');
                        var $configuratorSummaryAccessories = $('#configurator-summary-accessories-pack');
                        $configuratorSummaryAccessories.removeAttr('data-hx-revealed');

                        $('#configuratorConfigure-tab').on('click', function () {
                            $headerDriveAwayPrice.removeClass('text-primary');
                            $headerDriveAwayPrice.html(initialDriveAwayPrice);
                        });

                        $('#customse-prev').on('click', function () {
                            $configuratorFooterDriveAwayPriceMobile.removeClass('text-primary');
                            $configuratorFooterDriveAwayPriceMobile.html(initialDriveAwayPrice);
                        });

                        var vinTimerID = `timer-vin-timer-${data.items[0].id}`;
                        if (sessionStorage.getItem(vinTimerID)) {
                            console.info('Returning customer Order timer reset', vinTimerID);
                            sessionStorage.removeItem(vinTimerID);
                        }

                        var isShowroomStockSummary = urlParams.get('showroomStock') === 'true';
                        if (!isShowroomStockSummary) {
                            if (!crossBorderDelivery && data.totals.CrossBorderDelivery && data.totals.CrossBorderCharge !== '-') {
                                var crossBorderAvailabilityMessage = $('#cross-border-availability-msg').val();
                                var parsedAvailabilityMonths = crossBorderAvailabilityMessage.replace(/available\s*/i, '').trim();
                                $('#summary-cross-border-details').removeClass('d-none');
                                $('.summary-get-cross-border-text').text('Get it in ' + parsedAvailabilityMonths + ' for + $' + data.totals.CrossBorderCharge);
                            }
                            if (crossBorderDelivery) {
                                $('#summary-cross-border-price-summary').removeClass('d-none');
                                $('#summary-cross-border-price').text('$' + data.totals.CrossBorderCharge);
                            }
                        }

                        if (!configurator.isOnlineOrderingUiEnabled()) {
                            $('.configurator-footer-actions-test-drive').each(function () {
                                var $btn = $(this);
                                if ($btn.hasClass('btn-secondary')) {
                                    $btn.removeClass('btn-secondary').addClass('btn-primary');
                                }
                                $btn.find('span.color--nutral-90').each(function () {
                                    $(this).removeClass('color--nutral-90').addClass('white');
                                });
                            });
                        }

                        if ($('#configuratorSummary-tab').hasClass('active')) {
                            $('#summary-next').toggleClass('d-none', $('#configuratorOrder-tab').hasClass('d-none'));
                        }

                        configuratorStageSummary.updateFinanceComponent(data.finance);

                        if ($configuratorFooterDriveAwayPriceMobile.hasClass('opacity-50')) {
                            $configuratorFooterDriveAwayPriceMobile.removeClass('opacity-50');
                        }

                        if ($weeklyPaymentDetails.hasClass('opacity-50')) {
                            $weeklyPaymentDetails.removeClass('opacity-50');
                        }

                        $.spinner().stop();
                        syncUpsellCampaignUX();
                        setTimeout(() => {
                            frontendUtils.deleteUrlParams('showSummary');
                            localStorage.removeItem('syncTabRefresh');
                        }, 1000);
                    }
                });
            }
        }
    },
    updateStage: function (stage) {
        $(window).scrollTop(0);
        if (stage === 'summary') {
            $('body').trigger('configurator:stageUpdate:summary');
            // Hard-hide Summary CTA when already on Summary stage (desktop + mobile)
            $('#configurator-footer-actions-summary, #configurator-footer-actions-summary-m').addClass('d-none');
        }

        if (stage === 'configure') {
            $('body').trigger('configurator:stageUpdate:configure');
            configurator.header.updateDriveAwayPrice();
        }

        configurator.stage.configure.offScreenSliderFix();
    },

    isOnlineOrderingUiEnabled: function () {
        return $('body').data('isOnlineOrderingEnabled') === true;
    },

    /**
     * Sync online-ordering flag, labels, and CTA visibility from Product-Variation
     * (Show may omit usable location / bake a stale flag into HTML).
     * Desktop footer checkout stays stage-gated (summary click).
     *
     * @param {boolean} enabled
     */
    syncOnlineOrderingCTAs: function (enabled) {
        enabled = !!enabled;
        $('body').data('isOnlineOrderingEnabled', enabled);

        var $ctas = $(this.ONLINE_ORDERING_CTA_SELECTOR);

        $ctas.attr('data-online-ordering', enabled ? 'true' : 'false');

        $('.js-online-ordering-label').each(function () {
            var $el = $(this);
            var text = enabled ? $el.attr('data-label-online') : $el.attr('data-label-optout');

            if (text != null) {
                $el.text(text);
            }
        });

        if (!enabled) {
            $('.refund-message-card').find('span.pay-rest-amount-text').css('display', 'none');
        } else {
            $('.refund-message-card').find('span.pay-rest-amount-text').css('display', '');
        }

        this.applyOnlineOrderingCtaVisibility();
    },

    /**
     * Apply d-none for online-ordering CTAs from body flag + offline/modify URL context.
     * Does not touch disabled, URL, or stage-gated desktop checkout unhide.
     */
    applyOnlineOrderingCtaVisibility: function () {
        var enabled = this.isOnlineOrderingUiEnabled();
        var $ctas = $(this.ONLINE_ORDERING_CTA_SELECTOR);
        var flowContext = this.getConfiguratorFlowContext();

        if (!enabled) {
            $ctas.addClass('d-none');
        } else if (flowContext.suppressesOnlineOrderingCtas) {
            $('#configuratorOrder-tab').addClass('d-none');
            //$('#summary-footer-actions-checkout-m').addClass('d-none');
            $('.configurator-navigation .btn-order-online').addClass('d-none');
        } else {
            $('#configuratorOrder-tab').removeClass('d-none');
            //$('#summary-footer-actions-checkout-m').removeClass('d-none');
            $('.configurator-navigation .btn-order-online').removeClass('d-none');
        }

        this.syncSummaryNavConsumerCtas();
    },

    /**
     * One primary CTA on `.navbar-inner`. Visible navbar Test Drive omits the flyout
     * row; any other navbar primary (Next, Summary, Order Online, Update Order, Save
     * to CXP) shows Test Drive in the flyout. Ineligible still hides both.
     */
    syncSummaryNavConsumerCtas: function () {
        var $orderOnline = $(configuratorCtas.NAV_ORDER_ONLINE);
        var $navTd = $('.configurator-navigation .btn-test-drive');
        var $flyoutTd = $('.configurator-modal .list-group-item-action[data-view="test-drive"]');
        var suppress = this.getConfiguratorFlowContext().suppressesOnlineOrderingCtas;
        var orderableKnown = configuratorCtas.hasProductOrderableFlag();
        var consumerOrderOnline = $orderOnline.length && this.isOnlineOrderingUiEnabled() && !suppress;
        var showOrderOnline = consumerOrderOnline && orderableKnown && configuratorCtas.isProductOrderable();
        var awaitingStock = consumerOrderOnline && !orderableKnown;
        var navTdVisible;

        $orderOnline.toggleClass('d-none', !showOrderOnline);
        $orderOnline.removeClass('disabled').removeAttr('aria-disabled').prop('disabled', false);

        if (awaitingStock) {
            $navTd.addClass('d-none disabled').attr('aria-disabled', 'true');
            $flyoutTd.addClass('d-none disabled').attr('aria-disabled', 'true');

            return;
        }

        if (configuratorStageConfigure.lastIneligible === true) {
            $navTd.addClass('d-none disabled').attr('aria-disabled', 'true');
            $flyoutTd.addClass('d-none disabled').attr('aria-disabled', 'true');

            return;
        }

        if (showOrderOnline || suppress) {
            $navTd.addClass('d-none disabled').attr('aria-disabled', 'true');
        } else if (configuratorStageConfigure.lastIneligible === false) {
            $navTd.removeClass('d-none disabled').removeAttr('aria-disabled');
        }

        navTdVisible = $navTd.length > 0 && !$navTd.hasClass('d-none');

        if (navTdVisible) {
            $flyoutTd.addClass('d-none disabled').attr('aria-disabled', 'true');
        } else if (configuratorStageConfigure.lastIneligible === false) {
            $flyoutTd.removeClass('d-none disabled').removeAttr('aria-disabled');
        }
    },

    initBodyScrollDirection: function () {
        var body = document.body;
        let isActive = false;

        function isViewportNearPageBottom() {
            var doc = document.documentElement;
            var scrollY = window.scrollY || doc.scrollTop || 0;
            var innerH = window.innerHeight;
            var scrollH = Math.max(doc.scrollHeight, document.body.scrollHeight);
            return scrollY + innerH >= scrollH - 40;
        }

        function syncBodyScrollDirectionForViewport() {
            var isMobile = window.innerWidth < commonOptions.breakpoints.md;
            var nav = document.querySelector('.configurator-navigation');
            if (!nav) return;

            if (isMobile) {
                if (!isActive) {
                    scrollDirective.init(body, {
                        throttle: 100,
                        scrollUp: function () {
                            if (!isViewportNearPageBottom()) {
                                nav.classList.remove('scroll-down');
                            }
                        },
                        scrollDown: function () {
                            let mobileNavbarHeader = document.querySelector('.mobile-navbar-header');
                            if(window.scrollY > document.querySelector('.header').offsetHeight && mobileNavbarHeader.getAttribute('aria-hidden') !== 'true') {
                                nav.classList.add('scroll-down');
                            }
                        }
                    });
                    isActive = true;
                }
            } else if (isActive) {
                scrollDirective.destroy(body);
                nav.classList.remove('scroll-down');
                isActive = false;
            }
        }

        syncBodyScrollDirectionForViewport();
        $(window).on('resize.configuratorBodyScrollDirection', syncBodyScrollDirectionForViewport);
    },

    init: function () {
        this.initBodyScrollDirection();
        this.stage.configure.setupTemplateLoaders();
        this.header.initMobileNavigation();
        this.header.populateDriveAwayPrice();
        this.header.initHeadersEvents();
        this.syncOnlineOrderingCTAs($('#current-product').attr('data-is-online-ordering-enabled') === 'true');
        this.stage.configure.attributeSelect();
        configuratorStageConfigure.init();

        if (this.getConfiguratorFlowContext().suppressesOnlineOrderingCtas) {
            configuratorStageConfigure.hideAllTestDriveEntries();
        }

        this.stage.configure.initDefaultVariation();
        this.stage.configure.initStageEvents();
        this.stage.configure.initImageCarousels();

        this.stage.summary.initStageEvents();
        this.stage.summary.initSummaryActions();
        configuratorStageSummary.init();
        this.footer.actionLocationConfirm();
        this.footer.initFooterActions();
        this.footer.validateUserLocation();
        configuratorFooter.init();
        // this.uniqueCodeInputFill();
        // this.uniqueCodeInputFill('#flyout-build-unique-code-input', 'flyout-build-unique-code');
        // this.buildLoadedToast();
        productDisclalmers.init();
        configuratorPromotion.init();
        configuratorGradesAccordion.init();
        configuratorDownloadBrochure.init();
        // Save Execution Gate peer wiring: product/detail.registerSaveExecutionGate
        showHondaCentreChangedToastIfPending();
        showModelChangedToastIfPending();
        // Initial Build CTA/Configurator gating on first paint (safe, no-op if data absent)
        try {
            var decision = buildCTAEvaluator.evaluateFromDOM();

            if (decision) {
                applyConfiguratorDecision(decision);
            }
        } catch (e) {
            console.warn('Initial CTA rules evaluation failed:', e);
        }
    },

    /**
     * Offline CXP / modify-order URL flags that suppress Order Now CTAs.
     *
     * @private
     *
     * @returns {{ isOfflineCxp: boolean, isModifyOrder: boolean, suppressesOnlineOrderingCtas: boolean }}
     */
    getConfiguratorFlowContext: function () {
        var params = new URLSearchParams(window.location.search);
        var recordId = params.get('recordId') || '';
        var recordType = params.get('relatedRecordType') || '';
        var userId = params.get('userId') || '';
        var sessionId = params.get('sessionId') || '';
        var orderId = params.get('orderId') || '';
        var modifyCar = params.get('modifyCar') || '';
        var modifyAccessories = params.get('modifyAccessories') || '';
        var action = params.get('action') || '';

        var isOfflineCxp = !!(recordId || recordType || userId || sessionId) && !orderId;
        var isModifyOrder = !!((modifyCar && orderId) || (modifyAccessories && orderId) || (action === 'Changeconfigurationtonewoffer' && orderId) || (action === 'changeVIN' && orderId));

        return {
            isOfflineCxp: isOfflineCxp,
            isModifyOrder: isModifyOrder,
            suppressesOnlineOrderingCtas: isOfflineCxp || isModifyOrder
        };
    }
};

/**
 * True when `userloc` already contains a confirmed dealer + summary.
 *
 * @returns {boolean}
 */
function resolveHondaCentreChangedToastType() {
    try {
        const location = JSON.parse(frontendUtils.getCookie('userloc') || '{}');

        return location?.dealer?.dealerId && location?.summary
            ? 'change'
            : 'confirm';
    } catch {
        return 'confirm';
    }
}

/**
 * Honda Centre toast after reload: `confirm` = first location set, `change` = location updated.
 */
function showHondaCentreChangedToastIfPending() {
    let hondaCentreChangedToast;

    try {
        hondaCentreChangedToast = sessionStorage.getItem('hondaCentreChangedToast');

        if (!hondaCentreChangedToast) {
            return;
        }

        sessionStorage.removeItem('hondaCentreChangedToast');
    } catch (e) {
        return;
    }

    var $toast = $('.location-changed-toast');
    if (!$toast.length) return;

    // Defer until the toast container is in the DOM after htmx/spinner re-paints.
    setTimeout(function () {
        $toast.removeClass('confirm change');
        $toast.addClass(hondaCentreChangedToast === 'change' ? 'change' : 'confirm');
        $toast.toast({ delay: 8000 });
        $toast.toast('show');
    }, 200);
}

/**
 * Surface the "Model successfully changed" toast on the PDP after {@link changeModel.helpers.onConfirmModel}
 * navigates to another model (full page load). Flag is set in `changeModel.js` right before `location.assign`.
 */
function showModelChangedToastIfPending() {
    try {
        if (sessionStorage.getItem('modelChangedToast') !== '1') {
            return;
        }
        sessionStorage.removeItem('modelChangedToast');
    } catch (e) {
        return;
    }

    var $toast = $('.toast-model-changed');
    if (!$toast.length) return;

    setTimeout(function () {
        $toast.toast({ delay: 8000 });
        $toast.toast('show');
    }, 200);
}

// function updateCarImageSummaryPage(carImage, bgColor) {
//     const carImageElement = document.querySelector('.car-background-color-summary img');
//     carImageElement.setAttribute('src', carImage);
//     const carBackgroundElement = document.querySelector('.car-background-color-summary');
//     carBackgroundElement.style.backgroundColor = bgColor;
// }

// /**
//  * Updates Summary button text and border color based on vehicle background color
//  */
// function updateSummaryButtonColor() {
//     const summaryButton = document.querySelector('#configurator-footer-actions-summary-m');
//     if (!summaryButton) return;

//     const el = document.querySelector('.car-background-color');
//     if (!el) return;

//     const rgb = getComputedStyle(el).backgroundColor;
//     const hex = rgb.match(/\d+/g)
//         .map(x => (+x).toString(16).padStart(2, '0'))
//         .join('');
//     const isLightColor = frontendUtils.isHexLight(`#${hex.toUpperCase()}`);

//     if (isLightColor) {
//         summaryButton.classList.remove('btn-outline-light');
//         summaryButton.classList.add('btn-outline-dark');
//     } else {
//         summaryButton.classList.remove('btn-outline-dark');
//         summaryButton.classList.add('btn-outline-light');
//     }
// }

function updateCampaignParameters(campaigns) {
    if (campaigns) {
        frontendUtils.updateUrlParams({
            'camp': campaigns.map(item => item.id).join('&')
        });
    } else {
        frontendUtils.deleteUrlParams('camp');
    }
}

function updateVariantURLParameters(requestDataValue, variationProductID) {
    var params = new URLSearchParams(window.location.search);
    var variant = requestDataValue.grade || params.get('v') || '';
    var color = requestDataValue.color || params.get('sv') || '';
    var variationProductID = variationProductID || $('#current-product').attr('data-selectedvariationid') || params.get('m');

    var userId = params.get('userId') || '';
    var recordID = params.get('recordId') || '';
    var sessionId = params.get('sessionId') || '';
    var recordType = params.get('relatedRecordType') || '';
    var orderId = params.get('orderId') || '';
    var openLocationModal = params.get('openLocationModal') || '';
    var locationModalValue = openLocationModal && openLocationModal === 'true';

    configuratorCtas.syncCxpHookEnabled();

    if ((recordID || recordType || userId || sessionId) && !orderId) {
        $('.configurator-footer-actions-save').removeClass('d-flex').addClass('d-none');
        configuratorStageConfigure.hideAllTestDriveEntries();
        $('.offline-configurator-footer-action-share').removeClass('d-none').addClass('d-block');
        $('.configurator-footer__location__summary').addClass('d-flex');
        $('.summary-apply-for-finance-cta').addClass('d-none');
        $('.refund-message-card').addClass('d-none');
        $('.refundable-promotional-offer').addClass('d-none')
        $('#navbar-header-finance-summary').addClass('d-none');
        //$('#summary-footer-actions-checkout-m').addClass('d-none');
        $('.configurator-navigation .btn-order-online').addClass('d-none');
        configurator.applyOnlineOrderingCtaVisibility();
    }

    if (sessionId) {
        $('.configurator-location').addClass('cxp-configurator');
    }

    frontendUtils.updateUrlParams({
        'm': variationProductID,
        'v': variant,
        'sv': color
    });

    if (userId && sessionId && locationModalValue) {
        if (window.configurator && window.configurator.footer && typeof window.configurator.footer.openChangeHondaCentreView === 'function') {
            window.configurator.footer.openChangeHondaCentreView({ forceOpen: true });
        }
    }

    // if (!document.querySelector('.attribute-color .attribute-value [data-attr-value].selected')) {
    //     document.querySelector('.attribute-color .attribute-value [data-attr-value].selectable')?.click();
    // }
};



function modifyOrderURLParameters() {
    var params = new URLSearchParams(window.location.search);
    var modifyCar = params.get('modifyCar') || '';
    var modifyAccessories = params.get('modifyAccessories') || '';
    var orderId = params.get('orderId') || '';
    var variant = params.get('v') || '';
    var variantCarColor = params.get('sv') || '';
    var action = params.get('action') || '';
    var userId = params.get('userId') || '';
    var sessionId = params.get('sessionId') || '';
    var isDealerPortal = false;
    if (userId && sessionId) {
        isDealerPortal = true;
    }
    var purchedVariant = sessionStorage.getItem('modifySelectedOrderVariant') !== null ? JSON.parse(sessionStorage.getItem('modifySelectedOrderVariant')) : '';
    var nextButtonBody = '<span class="mr-2">Next</span><svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Size=L, Fill=Off, Direction=East"><path id="Union" d="M25.8215 23.95L15.9215 14.05L18.75 11.2215L31.4785 23.95L18.75 36.6785L15.9215 33.85L25.8215 23.95Z" fill="#ffffff"></path></g></svg>';
    if ((modifyCar && orderId) || (modifyAccessories && orderId) || (action == 'Changeconfigurationtonewoffer' && orderId) || (action == 'changeVIN' && orderId)) {
        $('.configurator-footer-actions-save').removeClass('d-flex').addClass('d-none');
        configuratorStageConfigure.hideAllTestDriveEntries();
        //$('#summary-footer-actions-checkout-m').removeClass('d-flex').addClass('d-none');
        $('.configurator-navigation .btn-order-online').removeClass('d-flex').addClass('d-none');
        if (!isDealerPortal) {
            $('.modify-order-cancel-button').removeClass('d-none').addClass('d-flex');
        }
        $('.modify-car-price-protected-alert-message').removeClass('d-none').addClass('d-flex');
        if (orderId && !userId && !sessionId) {
            $('.configurator-footer-change-location-button').removeClass('d-flex').addClass('d-none');
        }
        $('.modify-car-protected-price-text').removeClass('d-none').addClass('d-block');
        $('#configurator-footer-actions-select-location').css('pointer-events', 'none');
        $('#configurator-footer-actions-summary').text('').append(nextButtonBody);
        $('#configurator-footer-actions-summary-m').text('').append(nextButtonBody);
        $('#navbar-header-finance-summary').addClass('d-none');
        $('.summary-apply-for-finance-cta').addClass('d-none');
        $('.refund-message-card').addClass('d-none');
        $('.refundable-promotional-offer').addClass('d-none')
        configurator.applyOnlineOrderingCtaVisibility();
    }

    if (purchedVariant && modifyCar && (variant === purchedVariant.variant) && (variantCarColor === purchedVariant.variantColor)) {
        $('.product-recommendations-accessories-pack, .product-recommendations-accessories, .product-recommendations-accessories-membership, .product-recommendations-accessories-cross-sell').css({ 'pointer-events': 'none', 'opacity': '0.5' });
    }

    if ($('input[name="orderDeposit"]').length > 0 && $('input[name="orderDate"]').length > 0) {
        $('.configurator-summary__totals__deposit').find('.configurator-summary__totals__field-key').html('Deposit (Paid ' + $('input[name="orderDate"]').val() + ')');
        $('.configurator-summary__totals__deposit').find('#totals-field-value-deposit').html($('input[name="orderDeposit"]').val());
    }

    if (modifyAccessories || action == 'Changeconfigurationtonewoffer') {
        $('#attributes-slot, #configurator-nav-carmodal, #customse-prev, #select-grade-m-btn').addClass('disabled-configurator');

        if (variantCarColor === purchedVariant.variantColor) {
            var nonCurrentColorOptions = $('#attribute-color .color-attribute .color-value:not(.selected)').closest('button.detail');
            var currentColorOption = $('#attribute-color .color-attribute .color-value.selected').closest('.color-attribute');
            nonCurrentColorOptions.addClass('opacity-50').css('pointer-events', 'none').attr('disabled', 'disabled');
            nonCurrentColorOptions.siblings('.preview').css('pointer-events', 'none');
            currentColorOption.addClass('modify-order-ordered-value');
            currentColorOption.find('button.detail').prop('disabled', true);
        }
    }

    if (action == 'changeVIN' && orderId) {
        configuratorChangeVINMode.lockChangeVinMode();
    }
}

function updateAccessoriesURLParameters(items) {
    var params = new URLSearchParams(window.location.search);

    var groupedProductIDs = {
        type10: [],
        type11: [],
        typeOther: []
    };

    items.forEach(function (item) {
        if (item.recommendationType == '10') {
            groupedProductIDs.type10.push(item.productID);
        } else if (item.recommendationType == '11') {
            groupedProductIDs.type11.push(item.productID);
        } else {
            groupedProductIDs.typeOther.push(item.productID);
        }
    });

    var accPackPID = groupedProductIDs.type10.join('&');
    var protectionPID = groupedProductIDs.typeOther.join('&');
    var membershipPID = groupedProductIDs.type11.join('&');

    if (protectionPID) {
        frontendUtils.updateUrlParams({ 'acc': protectionPID });
    } else if (!protectionPID) {
        frontendUtils.deleteUrlParams('acc');
    }

    if (accPackPID) {
        frontendUtils.updateUrlParams({ 'accpk': accPackPID });
    } else if (!accPackPID) {
        frontendUtils.deleteUrlParams('accpk');
    }

    if (membershipPID) {
        frontendUtils.updateUrlParams({ 'mem': membershipPID });
    } else if (!membershipPID) {
        frontendUtils.deleteUrlParams('mem');
    }
    configuratorCtas.syncCxpHookEnabled();

}

function setDealerID(id, orderId) {
    var dealerId = id;
    var $dealerDiv = $('#store-dealer-url');
    var url = $dealerDiv.data('action');
    $.ajax({
        url: url,
        type: 'get',
        data: {
            dealerId: dealerId,
            orderId: orderId
        },
        dataType: 'json',
        success: function (data) {
            frontendUtils.setCookie(
                'userloc',
                JSON.stringify(data.storeObj)
            );
            $('#configurator-footer-actions-select-location').prop('disabled', true);
            changeCentreCtas.patch({ assignedDealer: true });
        }
    });
}

function updateInternalVehicleNumFields(internalVehicleNumHtml) {
    $('.internal-Vehicle-number').html(internalVehicleNumHtml);
}

function syncUpsellCampaignUX() {
    var $upsellAccessories = $('#product-recommendations-up-sell-slot .recommendation-tiles');
    var $upsellAccessoriesConfig = $('#product-recommendations-up-sell-slot .recommendation-lazy');
    var slidesCount = parseInt($upsellAccessories.data('slides-count')) || 1;
    slidesCount = slidesCount > 3 ? 3 : slidesCount;

    if (slidesCount <= 1) {
        if ($upsellAccessories.hasClass('slick-initialized')) {
            $upsellAccessories.slick('unslick');
            $upsellAccessoriesConfig.addClass('d-flex justify-content-center');
        }
        return;
    }

    $upsellAccessoriesConfig.removeClass('d-flex justify-content-center');

    $upsellAccessories.data('slick', {
        "slidesToShow": slidesCount,
        "slidesToScroll": slidesCount,
        "dots": true,
        "arrows": false
    });
    var slideConfig = $upsellAccessories.data('slick');
    slideConfig = {
        ...{
            arrows: false,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false,
                    }
                }
            ]
        }, ...slideConfig
    };

    if ($upsellAccessories.hasClass('slick-initialized')) {
        $upsellAccessories.slick('unslick');
    }

    $upsellAccessories.slick(slideConfig);
}


$(function () {
    // Core Configurator Configurator
    $(window).scrollTop(0);
    configurator.init();
    // Ensure body stage class matches URL when showSummary=true or Summary tab active
    try {
        var urlParams = new URLSearchParams(window.location.search);
        var showSummaryParam = urlParams.get('showSummary');
        var isSummaryTabActive = $('#configuratorSummary-tab').hasClass('active');
        var shouldShowSummaryStage = showSummaryParam === 'true' || isSummaryTabActive;

        if (shouldShowSummaryStage) {
            $('body').addClass('configurator-stage-summary');
        } else {
            $('body').removeClass('configurator-stage-summary');
        }
    } catch (error) {
        console.warn('Failed to set configurator stage class:', error);
    }

    // Additional Configurator Features
    Object.entries(FEATURES).forEach(function ([feature, enabled]) {
        if (enabled) {
            switch (feature) {
                case 'singleTabConfigurator':
                    singleTabConfigurator.init();
                    break;
                case 'configuratorRecommendation':
                    configuratorRecommendation.init();
                    break;
                case 'saveToCxpGate':
                    saveToCxpGate.init();
                    break;
                // Add more features here as needed
            }
        }
    });

    // Must stay last: handlers that react to the click itself are bound above.
    configurator.stage.configure.runLoadGradeClick();
});

/** -------------------------------------------------
 * Build CTA rules – front-end evaluator
 * Functions moved to buildCTAEvaluator.js module:
 * - getViewerContextFromURL()
 * - resolveMasterHide(productData)
 * - collectVariantFlags(productData)
 * - evaluateBuildCTAFront(productData, ctx)
 * -------------------------------------------------*/


/** -----------------------------------------------
 * Apply decision to Summary/Checkout CTAs + blocks
 * -----------------------------------------------*/
function applyConfiguratorDecision(decision) {
    // Persist for swatch filtering using module-level storage
    buildCTAEvaluator.setFlags(decision);

    // CRITICAL: Check for Update Order FIRST
    const params = new URLSearchParams(window.location.search);
    const orderId = params.get('orderId');
    const modifyCar = params.get('modifyCar');
    const modifyAccessories = params.get('modifyAccessories');
    const action = params.get('action');
    const isUpdateOrder = !!orderId || !!modifyCar || !!modifyAccessories || action === 'Changeconfigurationtonewoffer' || action === 'changeVIN';

    // Summary buttons + tabs
    const $btnSummary = $(configuratorCtas.BUILD);
    const $tabSummaryDesktop = $('#configuratorSummary-tab');
    const $tabSummaryMobile = $('#configuratorSummary-tab-m');

    const $checkoutCTAs = configuratorCtas.$configuratorAccess();

    // 1) Build CTA (Summary)
    // For Update Order, ALWAYS show Summary button even if showBuildCTA = false
    if (decision.showBuildCTA || isUpdateOrder) {
        $btnSummary.removeClass('d-none');
        $tabSummaryDesktop.removeClass('disabled');
        $tabSummaryMobile.removeClass('disabled');
    } else {
        $btnSummary.addClass('disabled d-none');
        $tabSummaryDesktop.addClass('disabled');
        $tabSummaryMobile.addClass('disabled');
    }

    // 2) Configurator access (soft block). Disable only — stock / DAP / ATC own re-enable.
    if (!decision.allowConfigurator) {
        $checkoutCTAs.addClass('disabled');

        if (!$('.toast-container').length > 0 && window.ecux && typeof window.ecux.notify === 'function') {
            window.ecux.notify('Configurator is unavailable for this model in new orders. You can access it only when updating an existing order.', '');
        }
    }

    // If we are already on Summary stage, the Summary CTA should never be visible
    if ($('body').hasClass('configurator-stage-summary')) {
        $('#configurator-footer-actions-summary, #configurator-footer-actions-summary-m').addClass('d-none');
    }
}

module.exports = {
    configurator: configurator,
    methods: {
        init: configurator.init
    },
};
